const stampedInit = function (e, t) {
  var a,
    s,
    r = {
      DEFAULT_ENDPOINT: e.stamped_ajax_url || "//stamped.io/api",
      SECURE_ENDPOINT: e.stamped_ajax_secure_url || "https://stamped.io/api",
      metafields: e.mainWidgetMetafields || "",
      exclude_main_css: e.stamped_exclude_main_css || !1,
      exclude_font: e.stamped_disable_font || !1,
      disable_single_review: e.stamped_disable_review_single || !1,
      modal_ugc_image_viewer: e.stamped_modal_ugc_viewer_type || "image",
      is_preview: e.isStampedLauncherPreview || !1,
      is_init_rewards: !0,
      is_force_jquery: e.stamped_force_jquery || !1,
      is_disable_cache_badge: e.stamped_disable_cache_badge || !1,
      is_disable_cache: e.stamped_disable_cache || !1,
      referral_code: null,
      is_rewards_code_copy: !1,
      is_ignore_submit_error: !1,
      rewards_apply_discount_url_format: e.stamped_rewards_apply_discount_url_format || "",
      slick_options: e.stamped_slick_options || {
        dots: !1,
        infinite: !1,
        speed: 300,
        slidesToShow: 4,
        slidesToScroll: 4,
        slide: ".stamped-review",
        initialSlide: 0,
        rows: 0,
        responsive: [
          { breakpoint: 1024, settings: { slidesToShow: 3, slidesToScroll: 3 } },
          { breakpoint: 600, settings: { slidesToShow: 2, slidesToScroll: 2 } },
          { breakpoint: 480, settings: { slidesToShow: 1, slidesToScroll: 1 } },
        ],
      },
      includes_options: { rewards_button_js: !0, rewards_window_js: !0 },
    },
    n = !1,
    d = !1;
  (e.StampedGlobalOptions = {}), (e.isInitializedStamped = !1);
  var o,
    l,
    p,
    c,
    m,
    u,
    h,
    v,
    g,
    f,
    w,
    y,
    b,
    S = [],
    k = [],
    _ = [],
    C = {},
    I = "div#stamped-main-widget",
    T = {},
    O =
      "html, body, div, span, applet, object, iframe, h1, h2, h3, h4, h5, h6, p, blockquote, pre, a, abbr, acronym, address, big, cite, code, del, dfn, em, img, ins, kbd, q, s, samp, small, strike, strong, sub, sup, tt, var, b, u, i, center, dl, dt, dd, ol, ul, li, fieldset, form, label, legend, table, caption, tbody, tfoot, thead, tr, th, td, article, aside, canvas, details, embed, figure, figcaption, footer, header, hgroup, menu, nav, output, ruby, section, summary, time, mark, audio, video { margin: 0; padding: 0; border: 0; font-size: 100%; font: inherit; vertical-align: baseline; }";
  function x() {
    var t,
      a = !1;
    return (
      (t = navigator.userAgent || navigator.vendor || e.opera),
      (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
        t
      ) ||
        /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
          t.substr(0, 4)
        )) &&
        (a = !0),
      a
    );
  }
  function E(e) {
    if ("click" === e.type) return !0;
    if ("keypress" !== e.type) return !1;
    var t = e.charCode || e.keyCode;
    return 32 === t || 13 === t || void 0;
  }
  function U(a) {
    var s = t.createElement("span");
    s.appendChild(t.createTextNode(a)), (s.id = "tempCopyToClipboard"), t.body.append(s);
    var r = t.createRange();
    r.selectNode(s),
      e.getSelection().removeAllRanges(),
      e.getSelection().addRange(r),
      t.execCommand("copy"),
      e.getSelection().removeAllRanges(),
      s.remove();
  }
  function R() {
    return (R =
      Object.assign ||
      function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var a = arguments[t];
          for (var s in a) Object.prototype.hasOwnProperty.call(a, s) && (e[s] = a[s]);
        }
        return e;
      }).apply(this, arguments);
  }
  (String.prototype.formatStringStamped = function () {
    for (var e = this, t = 0; t < arguments.length; t++) {
      var a = new RegExp("\\{" + t + "\\}", "gi");
      e = e.replace(a, arguments[t]);
    }
    return e;
  }),
    (function () {
      if ("function" == typeof e.CustomEvent) return !1;
      function a(e, a) {
        a = a || { bubbles: !1, cancelable: !1, detail: void 0 };
        var s = t.createEvent("CustomEvent");
        return s.initCustomEvent(e, a.bubbles, a.cancelable, a.detail), s;
      }
      (a.prototype = e.Event.prototype), (e.CustomEvent = a);
    })(),
    (e.lazyLoadOptionsStamped = { elements_selector: ".stamped-lazyload" }),
    e.addEventListener(
      "LazyLoad::Initialized",
      function (t) {
        e.LazyLoadStamped = t.detail.instance;
      },
      !1
    );
  var F, N, A;
  !(function () {
    "use strict";
    var a = void 0 !== e,
      s =
        (a && !("onscroll" in e)) ||
        ("undefined" != typeof navigator &&
          /(gle|ing|ro)bot|crawl|spider/i.test(navigator.userAgent)),
      r = a && "IntersectionObserver" in e,
      i = a && "classList" in t.createElement("p"),
      n = {
        elements_selector: "img",
        container: s || a ? t : null,
        threshold: 300,
        thresholds: null,
        data_src: "src",
        data_srcset: "srcset",
        data_sizes: "sizes",
        data_bg: "bg",
        class_loading: "stamped-lazyload-loading",
        class_loaded: "stamped-lazyload-loaded",
        class_error: "stamped-lazyload-error",
        load_delay: 0,
        auto_unobserve: !0,
        callback_enter: null,
        callback_exit: null,
        callback_reveal: null,
        callback_loaded: null,
        callback_error: null,
        callback_finish: null,
        use_native: !1,
      },
      d = function (a, s) {
        var r,
          i = new a(s);
        try {
          r = new CustomEvent("LazyLoad::Initialized", { detail: { instance: i } });
        } catch (a) {
          (r = t.createEvent("CustomEvent")).initCustomEvent("LazyLoad::Initialized", !1, !1, {
            instance: i,
          });
        }
        try {
          e.dispatchEvent(r);
        } catch (s) {}
      },
      o = function (e, t) {
        return e.getAttribute("data-" + t);
      },
      l = function (e, t, a) {
        var s = "data-" + t;
        null !== a ? e.setAttribute(s, a) : e.removeAttribute(s);
      },
      p = function (e) {
        return "true" === o(e, "was-processed");
      },
      c = function (e, t) {
        return l(e, "ll-timeout", t);
      },
      m = function (e) {
        return o(e, "ll-timeout");
      },
      u = function (e, t) {
        e && e(t);
      },
      h = function (e, t) {
        (e._loadingCount += t),
          0 === e._elements.length && 0 === e._loadingCount && u(e._settings.callback_finish);
      },
      v = function (e) {
        for (var t, a = [], s = 0; (t = e.children[s]); s += 1) "SOURCE" === t.tagName && a.push(t);
        return a;
      },
      g = function (e, t, a) {
        a && e.setAttribute(t, a);
      },
      f = function (e, t) {
        g(e, "sizes", o(e, t.data_sizes)),
          g(e, "srcset", o(e, t.data_srcset)),
          g(e, "src", o(e, t.data_src));
      },
      w = {
        IMG: function (e, t) {
          var a = e.parentNode;
          a &&
            "PICTURE" === a.tagName &&
            v(a).forEach(function (e) {
              f(e, t);
            }),
            f(e, t);
        },
        IFRAME: function (e, t) {
          g(e, "src", o(e, t.data_src));
        },
        VIDEO: function (e, t) {
          v(e).forEach(function (e) {
            g(e, "src", o(e, t.data_src));
          }),
            g(e, "src", o(e, t.data_src)),
            e.load();
        },
      },
      y = function (e, t) {
        i ? e.classList.add(t) : (e.className += (e.className ? " " : "") + t);
      },
      b = function (e, t, a) {
        e.addEventListener(t, a);
      },
      S = function (e, t, a) {
        e.removeEventListener(t, a);
      },
      k = function (e, t, a) {
        S(e, "load", t), S(e, "loadeddata", t), S(e, "error", a);
      },
      _ = function (e, t, a) {
        var s = a._settings,
          r = t ? s.class_loaded : s.class_error,
          n = t ? s.callback_loaded : s.callback_error,
          d = e.target;
        !(function (e, t) {
          i
            ? e.classList.remove(t)
            : (e.className = e.className
                .replace(new RegExp("(^|\\s+)" + t + "(\\s+|$)"), " ")
                .replace(/^\s+/, "")
                .replace(/\s+$/, ""));
        })(d, s.class_loading),
          y(d, r),
          u(n, d),
          h(a, -1);
      },
      C = ["IMG", "IFRAME", "VIDEO"],
      I = function (e, t) {
        var a = t._observer;
        O(e, t), a && t._settings.auto_unobserve && a.unobserve(e);
      },
      T = function (e) {
        var t = m(e);
        t && (clearTimeout(t), c(e, null));
      },
      O = function (e, t, a) {
        var s = t._settings;
        (!a && p(e)) ||
          (C.indexOf(e.tagName) > -1 &&
            ((function (e, t) {
              var a = function a(r) {
                  _(r, !0, t), k(e, a, s);
                },
                s = function s(r) {
                  _(r, !1, t), k(e, a, s);
                };
              !(function (e, t, a) {
                b(e, "load", t), b(e, "loadeddata", t), b(e, "error", a);
              })(e, a, s);
            })(e, t),
            y(e, s.class_loading)),
          (function (e, t) {
            var a,
              s,
              r = t._settings,
              i = e.tagName,
              n = w[i];
            if (n)
              return (
                n(e, r),
                h(t, 1),
                void (t._elements =
                  ((a = t._elements),
                  (s = e),
                  a.filter(function (e) {
                    return e !== s;
                  })))
              );
            !(function (e, t) {
              var a = o(e, t.data_src),
                s = o(e, t.data_bg);
              a && (e.style.backgroundImage = 'url("'.concat(a, '")')),
                s && (e.style.backgroundImage = s);
            })(e, r);
          })(e, t),
          (function (e) {
            l(e, "was-processed", "true");
          })(e),
          u(s.callback_reveal, e),
          u(s.callback_set, e));
      },
      x = function (e) {
        return (
          !!r &&
          ((e._observer = new IntersectionObserver(
            function (t) {
              t.forEach(function (t) {
                return (function (e) {
                  return e.isIntersecting || e.intersectionRatio > 0;
                })(t)
                  ? (function (e, t) {
                      var a = t._settings;
                      u(a.callback_enter, e),
                        a.load_delay
                          ? (function (e, t) {
                              var a = t._settings.load_delay,
                                s = m(e);
                              s ||
                                ((s = setTimeout(function () {
                                  I(e, t), T(e);
                                }, a)),
                                c(e, s));
                            })(e, t)
                          : I(e, t);
                    })(t.target, e)
                  : (function (e, t) {
                      var a = t._settings;
                      u(a.callback_exit, e), a.load_delay && T(e);
                    })(t.target, e);
              });
            },
            {
              root: (a = e._settings).container === t ? null : a.container,
              rootMargin: a.thresholds || a.threshold + "px",
            }
          )),
          !0)
        );
        var a;
      },
      E = ["IMG", "IFRAME"],
      U = function (e, t) {
        return (function (e) {
          return e.filter(function (e) {
            return !p(e);
          });
        })(
          ((a =
            e ||
            (function (e) {
              return e.container.querySelectorAll(e.elements_selector);
            })(t)),
          Array.prototype.slice.call(a))
        );
        var a;
      },
      F = function (e, t) {
        (this._settings = (function (e) {
          return R({}, n, e);
        })(e)),
          (this._loadingCount = 0),
          x(this),
          this.update(t);
      };
    (F.prototype = {
      update: function (e) {
        var t,
          a = this,
          r = this._settings;
        (this._elements = U(e, r)),
          !s && this._observer
            ? (r.use_native &&
                "loading" in HTMLImageElement.prototype &&
                ((t = this)._elements.forEach(function (e) {
                  -1 !== E.indexOf(e.tagName) && (e.setAttribute("loading", "lazy"), O(e, t));
                }),
                (this._elements = U(e, r))),
              this._elements.forEach(function (e) {
                a._observer.observe(e);
              }))
            : this.loadAll();
      },
      destroy: function () {
        var e = this;
        this._observer &&
          (this._elements.forEach(function (t) {
            e._observer.unobserve(t);
          }),
          (this._observer = null)),
          (this._elements = null),
          (this._settings = null);
      },
      load: function (e, t) {
        O(e, this, t);
      },
      loadAll: function () {
        var e = this;
        this._elements.forEach(function (t) {
          I(t, e);
        });
      },
    }),
      a &&
        (function (e, t) {
          if (t)
            if (t.length) for (var a, s = 0; (a = t[s]); s += 1) d(e, a);
            else d(e, t);
        })(F, e.lazyLoadOptionsStamped);
  })();
  function j(a, i) {
    i
      ? (qe("Using included jQ"), (s = i), (e.jQueryStamped = s), qe(s))
      : (qe("Loaded jQ"), (e.jQueryStamped = s)),
      /msie/.test(e.navigator.userAgent.toLowerCase()) && (s.support.cors = !0),
      1 != r.exclude_font &&
        s("head").append(
          s("<link/>", {
            rel: "stylesheet",
            href: "//fonts.googleapis.com/css?family=Open+Sans:400,600&display=swap",
            type: "text/css",
          })
        );
    var n = je("stamped_referral_code") || je("stamped_ref");
    n && (Ge("stamped_referral_code", { code: n }), (r.referral_code = n));
    var o = Pe("stamped_referral_code");
    o && o.code && (r.referral_code = o.code),
      qe("Library Starting..."),
      s.isReady
        ? q()
        : s(t).ready(function () {
            q();
          }),
      setTimeout(function () {
        d || (qe("Library not started, fallback"), q());
      }, 3e3);
  }
  function q() {
    d || (qe("Started library"), Ye("stamped:init:starting"), L(), G()), (d = !0);
  }
  function L() {
    if ((qe("Starting UGC..."), (o = s(I)).length)) {
      if (s.trim(o.html())) {
        te(), pe(), ne(), ie(), Z(), de();
        try {
          e.LazyLoadStamped && LazyLoadStamped.update && LazyLoadStamped.update();
        } catch (e) {}
      } else ee();
      s(t).on("click keypress", ".stamped-summary-ratings .summary-rating", function (e) {
        if (!0 === E(e)) {
          var t = s(this).find(".summary-rating-bar"),
            a = t.attr("data-rating"),
            r = t.hasClass("selected");
          s(".stamped-summary-ratings .summary-rating").each(function () {
            s(this).removeClass("selected");
          }),
            s(".summary-rating-bar").each(function () {
              s(this).removeClass("selected");
            }),
            a &&
              (r
                ? (Re(1), s(".stamped-summary-ratings").removeClass("selected"))
                : (t.addClass("selected"),
                  s(this).addClass("selected"),
                  s(".stamped-summary-ratings").addClass("selected"),
                  Re(1, a)));
        }
      }),
        s(t).on("mouseover mouseout", ".stamped-form-review-rating a.fa", function (e) {
          var t, a, r;
          (t = e.currentTarget),
            (r = s(t).attr("data-value")),
            (a = s(t).parent()),
            "mouseover" === e.type
              ? (a
                  .find("a.fa:lt(" + r + ")")
                  .removeClass("fa-star-o")
                  .addClass("fa-star"),
                a
                  .find("a.fa:gt(" + (r - 1) + ")")
                  .removeClass("spr-icon-star-hover")
                  .addClass("fa-star-o"))
              : a.find("a.fa").removeClass("fa-star").addClass("fa-star-o");
        }),
        s(t).on("click keypress", ".stamped-tabs li", function (e) {
          !0 === E(e) && ve(this);
        }),
        s(t).on("keypress", ".stamped-summary-actions-newreview", function (e) {
          !0 === E(e) && Oe("review");
        }),
        s(t).on("keypress", ".stamped-summary-actions-newquestion", function (e) {
          !0 === E(e) && Oe("question");
        }),
        s(t).on("keypress", ".stamped-form-input a", function (e) {
          !0 === E(e) && xe(this);
        }),
        (a =
          "#shopry-rating-wrapper a.shopry-thumbs-up, #shopry-rating-wrapper a.shopry-thumbs-down, #shopry-rating-holder a.shopry-thumbs-up, #shopry-rating-holder a.shopry-thumbs-down, #stamped-rating-holder a.stamped-thumbs-up, #stamped-rating-holder a.stamped-thumbs-down, .stamped-rating-holder a.stamped-thumbs-up, .stamped-rating-holder a.stamped-thumbs-down"),
        s(t)
          .off("click keypress", a)
          .on("click keypress", a, function (t) {
            if (!0 === E(t)) {
              var a = s(this).attr("data-review-id"),
                i = s(this).attr("data-question-id"),
                n = s(this).attr("data-rating"),
                d = o.attr("data-product-id"),
                l = s(this),
                p = l.parent();
              p.fadeTo("slow", 0.3), l.addClass("disable-link");
              var c = a ? "reviews" : "questions";
              s.ajax({
                type: "POST",
                url: r.SECURE_ENDPOINT + "/" + c + "/vote",
                data: {
                  productId: d,
                  reviewId: a,
                  questionId: i,
                  vote: n,
                  apiKey: e.StampedGlobalOptions.apiKey,
                  sId: e.StampedGlobalOptions.sId,
                  storeUrl: e.StampedGlobalOptions.storeUrl,
                },
                success: function (e) {
                  s(".stamped-thumbs-up i", p).html("&nbsp; " + e.voteUp),
                    s(".stamped-thumbs-down i", p).html("&nbsp; " + e.voteDown),
                    p.fadeTo("slow", 1),
                    l.removeClass("disable-link");
                },
              });
            }
          }),
        (function () {
          var e = ".stamped-share-button, .stamped-share-icon";
          s(t)
            .off("click keypress", e)
            .on("click keypress", e, function (e) {
              if (!0 === E(e)) {
                var t = s(this).parent().find(".stamped-share-links");
                t.fadeToggle();
              }
            });
        })(),
        s(t).on("click keypress", ".stamped-summary-actions-mobile-filter", function (e) {
          if (!0 === E(e)) {
            var t = s(".stamped-filters-wrapper");
            t.hasClass("stamped-mobile-visible")
              ? (t.slideUp(), t.removeClass("stamped-mobile-visible"))
              : (t.slideDown(), t.addClass("stamped-mobile-visible"));
          }
        }),
        s(t).on("click keypress", ".stamped-summary-keywords-list li", function (e) {
          if (!0 === E(e)) {
            var t = s(this);
            t.hasClass("selected")
              ? (s(".stamped-summary-keywords-list li").removeClass("selected"),
                s(o).removeAttr("data-keyword"))
              : (s(".stamped-summary-keywords-list li").removeClass("selected"),
                t.addClass("selected"),
                s(o).attr("data-keyword", t.text().trim())),
              s(".stamped-summary-actions-clear").show(),
              Re(1);
          }
        }),
        s(t).on("change keyup", ".stamped-reviews-search-input", function (e) {
          var t = s(this).val();
          if (
            (t
              ? (s(".stamped-reviews-search-clear").show(),
                s(".stamped-reviews", o).attr("data-filtered", "true"))
              : (s(".stamped-reviews-search-clear").hide(),
                s(".stamped-reviews", o).removeAttr("data-filtered")),
            13 == e.keyCode)
          ) {
            var t = s(this).val();
            t &&
              (s(o).attr("data-search", t.trim()),
              s(".stamped-summary-actions-clear").show(),
              oe(),
              Re(1));
          }
        }),
        s(t).on("click keypress", ".stamped-reviews-search-button", function (e) {
          if (!0 === E(event)) {
            var t = s(".stamped-reviews-search-input").val();
            t &&
              (s(o).attr("data-search", t.trim()),
              s(".stamped-summary-actions-clear").show(),
              oe(),
              Re(1));
          }
        }),
        s(t).on("click keypress", ".stamped-reviews-search-clear", function (e) {
          !0 === E(e) &&
            (s(".stamped-reviews-search-clear").hide(),
            s(".stamped-reviews-search-input").val(""),
            s(o).removeAttr("data-search"),
            Re(1));
        }),
        s(t).on("click keypress", ".stamped-summary-actions-clear", function (e) {
          if (!0 === E(e)) {
            var t = s(this).data("type");
            Fe(t);
          }
        }),
        s(t).on("change keyup", ".stamped-questions-search-input", function (e) {
          var t = s(this).val();
          if (
            (t
              ? (s(".stamped-questions-search-clear").show(),
                s(".stamped-questions", o).attr("data-filtered", "true"))
              : (s(".stamped-questions-search-clear").hide(),
                s(".stamped-questions", o).removeAttr("data-filtered")),
            13 == e.keyCode)
          ) {
            var t = s(this).val();
            t &&
              (s(o).attr("data-search-qna", t.trim()),
              s(".stamped-summary-actions-clear").show(),
              Ue());
          }
        }),
        s(t).on("click keypress", ".stamped-questions-search-button", function (e) {
          if (!0 === E(event)) {
            var t = s(".stamped-questions-questions-input").val();
            t &&
              (s(o).attr("data-search-qna", t.trim()),
              s(".stamped-summary-actions-clear").show(),
              Ue());
          }
        }),
        s(t).on("click keypress", ".stamped-questions-search-clear", function (e) {
          !0 === E(e) &&
            (s(".stamped-questions-search-clear").hide(),
            s(".stamped-questions-search-input").val(""),
            s(o).removeAttr("data-search-qna"),
            Ue());
        }),
        s(t).one("stamped:reviews:loaded", function () {
          qe("Main Widget event triggered reload once"),
            te(),
            pe(),
            ne(),
            de(),
            je("write_review") && Oe("review"),
            je("write_question") && Oe("question");
        }),
        s(t).on("stamped:reviews:loaded", function (t) {
          qe("Main Widget event triggered reload"), (_ = []), ie(), Z();
          try {
            e.LazyLoadStamped && LazyLoadStamped.update && LazyLoadStamped.update();
          } catch (e) {}
          s(".stamped-tabs > li").click(function () {
            var e = Array.prototype.slice.call(this.parentNode.children);
            e.forEach(function (e) {
              e.setAttribute("aria-selected", !1);
            });
            var t = this.getAttribute("aria-selected");
            this.setAttribute("aria-selected", !JSON.parse(t));
          }),
            s(".stamped-share-icon").click(function () {
              var e = s(this).siblings(".stamped-share-links"),
                t = e.attr("aria-expanded"),
                a = void 0 !== t && !1 !== t ? t : "false";
              e.attr("aria-expanded", "true" == a ? "false" : "true"),
                s(this).toggleClass("stamped-active");
            }),
            s(".stamped-rating-holder > a").click(function () {
              var e = Array.prototype.slice.call(this.parentNode.children);
              e.forEach(function (e) {
                e.setAttribute("aria-pressed", !1);
              });
              var t = this.getAttribute("aria-pressed");
              this.setAttribute("aria-pressed", !JSON.parse(t));
            });
        });
    }
    var a;
    s(t).one("stamped:launcher:loaded", function (t) {
      var a = je("rewards-launcher");
      s(e).on("hashchange", function () {
        location.hash.indexOf("stamped-rewards") >= 0 && K();
      }),
        a && ("open" == a && K(), a.indexOf("view-") > -1 && (K(!0), V(a)));
    }),
      ae(),
      se();
    var i = je("stamped_r_id");
    i &&
      1 != r.disable_single_review &&
      (function (a) {
        s.ajax({
          type: "GET",
          url: r.SECURE_ENDPOINT + "/widget/reviews",
          data: {
            reviewId: a,
            apiKey: e.StampedGlobalOptions.apiKey,
            sId: e.StampedGlobalOptions.sId,
            storeUrl: e.StampedGlobalOptions.storeUrl,
            type: "single",
            showAvatar: "True",
            minRating: 1,
          },
          success: function (e) {
            e.data && StampedFn.openUGCModal([e.data], 0, t, 1, !1, 0);
          },
          error: function (e) {},
        });
      })(i);
  }
  function G(e) {
    qe("Starting Rewards...");
    var t = s("#stamped-rewards-init");
    if (e && e.customer) return qe("Started Rewards with direct data"), (T = e), void D();
    e
      ? (qe("Started Rewards with JS data"), (T.customer = e), P())
      : t.length > 0
      ? (qe("Started Rewards with div data"),
        (T.customer = {
          customerId: t.data("customer-id"),
          customerEmail: t.data("customer-email"),
          customerFirstName: t.data("customer-first-name"),
          customerLastName: t.data("customer-last-name"),
          customerTags: t.data("customer-tags"),
          customerLocale: t.data("customer-locale"),
          totalOrders: 0,
          totalSpent: t.data("customer-total-spent"),
          isAcceptMarketing: t.data("customer-accepts-marketing"),
          authToken: t.data("key-auth"),
        }),
        P())
      : qe("Started Rewards no init customer data");
  }
  function P() {
    qe("Loading Rewards API init...");
    var t = r.metafields || "";
    T && T.customer && t && (T.customer.metafields = t);
    var a = JSON.stringify(T.customer),
      i = r.is_test;
    s.ajax({
      type: "POST",
      url:
        r.SECURE_ENDPOINT +
        "/v2/rewards/init?" +
        s.param({
          apiKey: e.StampedGlobalOptions.apiKey,
          sId: e.StampedGlobalOptions.sId,
          storeUrl: e.StampedGlobalOptions.storeUrl,
          debug: null,
          isTest: i,
          isPreview: r.is_preview,
          referralCode: r.referral_code,
        }),
      xhrFields: { withCredentials: !0 },
      data: a,
      dataType: "json",
      contentType: "application/json; charset=utf-8",
      success: function (e, t, a) {
        Ye("stamped:rewards:init"), (T = e), D();
      },
    });
  }
  function D() {
    !(function () {
      if (!s("#stamped-rewards-init").length) {
        var e = t.createElement("div");
        e.setAttribute("id", "stamped-rewards-init"), t.body.appendChild(e);
      }
    })(),
      T &&
        T.html &&
        ((l = s("#stamped-rewards-init")).html(T.html.main),
        (function () {
          (m = s(".stamped-rewards-launcher", l)),
            (u = s(".stamped-launcher-button", l)),
            (g = s("<iframe>"));
          var e = u.html();
          qe("Func _buildIframeLauncher: width:" + u.width(), 1),
            qe("Func _buildIframeLauncher: outerWidth:" + u.outerWidth(), 1),
            qe("Func _buildIframeLauncher: var launcherWidth:" + (b = u.width() + 40), 1),
            u.width(b),
            u.html(g),
            m.hide(),
            setTimeout(function () {
              (f = g[0].contentWindow.document),
                (g[0].contentWindow.StampedFn = StampedFn),
                (g[0].contentWindow.jQuery = jQuery);
              var t = s("body", f),
                a = s("head", f);
              if (
                (t.html(e),
                t.append(s("#stamped-rewards-main-css", l).clone()),
                a.append(
                  s("<link/>", {
                    rel: "stylesheet",
                    href: "//cdn1.stamped.io/files/rewards-launcher.min.css",
                    type: "text/css",
                  })
                ),
                0 != r.includes_options.rewards_button_js)
              ) {
                var i = f.createElement("script");
                (i.type = "text/javascript"),
                  (i.src = "//kit.fontawesome.com/59de3073ed.js"),
                  i.setAttribute("data-observe-mutations", "true"),
                  f.body.appendChild(i);
              }
              a.append(
                "<style>" +
                  O +
                  ' body { overflow:hidden; } .stamped-launcher-icon-opened { font-family:"Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif; display:inline-block; width: 100%; margin-top: -2px; text-align:center;}</style>'
              ),
                x() && t.attr("data-mobile", !0),
                (h = s(".stamped-launcher-icon-closed", t)),
                (v = s(".stamped-launcher-icon-opened", t)),
                setTimeout(function () {
                  m.fadeIn();
                }, 800);
            }, 800);
        })(),
        (function () {
          (p = s(".stamped-rewards-base", l)),
            ($launcherCss = s("#stamped-rewards-main-css", l).clone()),
            (w = s("<iframe>"));
          var a = p.html();
          p.html(w),
            setTimeout(function () {
              (y = w[0].contentWindow.document),
                (w[0].contentWindow.StampedFn = StampedFn),
                (w[0].contentWindow.jQuery = jQuery);
              var i = s("body", y),
                n = s("head", y);
              i.html(a),
                i.append(s("#stamped-rewards-main-css", l).clone()),
                n.append(
                  s("<link/>", {
                    rel: "stylesheet",
                    href: "//cdn1.stamped.io/files/rewards-main.min.css",
                    type: "text/css",
                  })
                ),
                1 != r.exclude_font &&
                  n.append(
                    s("<link/>", {
                      rel: "stylesheet",
                      href: "//fonts.googleapis.com/css?family=Open+Sans:400,600&display=swap",
                      type: "text/css",
                    })
                  ),
                n.append(
                  "<script>window.FontAwesomeConfig = { searchPseudoElements: true };</script>"
                );
              var d,
                o = y.createElement("script");
              (o.type = "text/javascript"),
                (o.src = "//kit.fontawesome.com/59de3073ed.js"),
                o.setAttribute("data-observe-mutations", "true"),
                o.setAttribute("data-search-pseudo-elements", "true"),
                y.body.appendChild(o),
                i.append(
                  "<style>" +
                    O +
                    ' .stamped-rewards-window { font-family:"Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif; }</style>'
                ),
                x() && i.attr("data-mobile", !0),
                T.customer && T.customer.customerEmail
                  ? i.attr("data-logged-in", !0)
                  : i.attr("data-logged-in", !1),
                1 == T.branding && i.attr("data-branding", !0),
                ($wrapperCards = s("#stamped-rewards-cards", y)),
                ($wrapperViews = s("#stamped-rewards-views", y)),
                s(y).on("click", ".stamped-rewards-header-close", function () {
                  K();
                }),
                s(t).on("touchstart", function () {
                  d = !0;
                }),
                s(t).on("touchmove", function () {
                  d = !1;
                }),
                s(t).on("click touchend", function (e) {
                  if (("click" === e.type && (d = !0), d))
                    if (
                      "stamped-rewards-init" === e.target.id ||
                      s(e.target).parents("#stamped-rewards-init").length ||
                      s(e.target).parents(".stamped-rewards-base").length ||
                      s(e.target).parents(".stamped-rewards-launcher").length ||
                      s(e.target).parents("#stamped-rewards-widget").length
                    );
                    else {
                      var t = s(".stamped-rewards-base", l),
                        a = t.hasClass("opened");
                      setTimeout(function () {
                        a && StampedFn.toggleLauncher();
                      }, 300);
                    }
                }),
                s(y).on(
                  "click",
                  '[data-campaign-completed="false"] .stamped-reward-card-button-earn',
                  function () {
                    var e = s(this).parent(".stamped-rewards-card-earn"),
                      t = s(this),
                      a = e.data("campaign-id"),
                      r = e.data("event-type");
                    if ("AccountBirthday" == r) {
                      var i = s(".stamped-rewards-birthday-input-holder", y);
                      i.show();
                      var n = s(
                          ".stamped-rewards-birthday-input-holder select.DOBDay option:checked",
                          y
                        ).val(),
                        d = s(
                          ".stamped-rewards-birthday-input-holder select.DOBMonth option:checked",
                          y
                        ).val(),
                        o = s(
                          ".stamped-rewards-birthday-input-holder select.DOBYear option:checked",
                          y
                        ).val();
                      if (n && d && o) {
                        X(t, "loading", !0);
                        var l = o + "-" + d + "-" + n;
                        Q({
                          campaignId: a,
                          campaignEventType: r,
                          birthday: l,
                          callback: function () {
                            X(t, "active", !0, null, function () {
                              e.attr("data-campaign-completed", "true"),
                                e.attr("data-birthday", "true"),
                                P();
                            }),
                              i.hide();
                          },
                        });
                      }
                    } else
                      "Review" == r || "ReviewPhoto" == r || "ReviewVideo" == r
                        ? (s('.stamped-rewards-header-menu span[data-target="reviews"]', y).trigger(
                            "click"
                          ),
                          V("main"))
                        : (X(t, "loading", !0),
                          Q({
                            campaignId: a,
                            campaignEventType: r,
                            callback: function () {
                              X(t, "active", !0, null, function () {
                                e.attr("data-campaign-completed", "true");
                              });
                            },
                          }));
                  }
                ),
                s(y).on(
                  "click",
                  '[data-campaign-redeemable="true"] .stamped-reward-card-button-spend',
                  function () {
                    var e = s(this),
                      t = e.parent(".stamped-rewards-card-spend"),
                      a = t.data("campaign-id"),
                      r = t.data("coupon-type");
                    "Variable" == r
                      ? V("view-redeem-variable", null, { entityId: a })
                      : (X(e, "loading", !0),
                        J({
                          campaignId: a,
                          callback: function (t) {
                            V("view-coupon", null, t.rewardCampaignCoupon), X(e, "active", !0, 1);
                          },
                        }));
                  }
                ),
                s(y).on("click", ".stamped-reward-referral-platforms button", function () {
                  var t,
                    a = s(this).attr("href");
                  a &&
                    ((t = a),
                    e.open(
                      t,
                      "_blank",
                      "location=yes,height=500,width=500,top=50,left=50,scrollbars=yes,status=yes"
                    ));
                }),
                s(y).on("click", ".stamped-rewards-header-menu span", function () {
                  var e = s(this).attr("data-target"),
                    t = $wrapperCards.attr("data-target");
                  e != t &&
                    ($wrapperCards.attr("data-target", e),
                    $(e),
                    s(".stamped-rewards-content-container", y).scrollTop(0),
                    s(".stamped-rewards-header-menu .active", y).removeClass("active"),
                    s(this, y).addClass("active"));
                }),
                s(".stamped-rewards-content-container", y).on("scroll", function () {
                  var e = s(".stamped-rewards-content-container", y).scrollTop();
                  if (e <= 1)
                    return (
                      s(".stamped-rewards-background", y).height("200px"),
                      void s(".stamped-rewards-header", y).height("auto")
                    );
                  var t = s(".stamped-rewards-header-content", y).outerHeight() + 15;
                  s(".stamped-rewards-header", y).css("min-height", "70px");
                  var a = 200;
                  (a -= e), s(".stamped-rewards-background", y).height(a);
                  var r = t;
                  (r -= e), s(".stamped-rewards-header", y).height(r);
                }),
                $("rewards"),
                Ye("stamped:launcher:loaded");
            }, 1e3);
        })(),
        re());
  }
  function K(t) {
    var a = p.hasClass("opened");
    s("body", y).addClass("opened"),
      a
        ? 1 != t &&
          (qe("Func _toggleRewardsModal: var launcherWidth:" + b, 1),
          p.removeClass("opened"),
          p.fadeOut(),
          m.removeClass("opened"),
          h.removeClass("rotateIn"),
          v.removeClass("fadeOut"),
          v.addClass("fadeIn"),
          u.animate({ width: b + "px" }, 0),
          setTimeout(function () {
            V("main");
          }, 1e3),
          Ye("stamped:launcher:closed"))
        : (setTimeout(function () {
            p.addClass("opened");
          }, 100),
          m.addClass("opened"),
          p.fadeIn(),
          h.addClass("rotateIn"),
          h.removeClass("rotateOut"),
          v.addClass("fadeOut"),
          v.removeClass("fadeIn"),
          u.animate({ width: "40px" }, 0),
          s(".stamped-rewards-content-container", y).scrollTop(0),
          s(".stamped-rewards-header", y).css("height", "auto"),
          Ye("stamped:launcher:opened"),
          "true" != _e("stamped-launcher-opened") &&
            (s.ajax({
              type: "POST",
              url:
                r.SECURE_ENDPOINT +
                "/tracking/event?" +
                s.param({
                  apiKey: e.StampedGlobalOptions.apiKey,
                  sId: e.StampedGlobalOptions.sId,
                  storeUrl: e.StampedGlobalOptions.storeUrl,
                  source: "launcher",
                  event: "open",
                }),
              dataType: "json",
              success: function (e, t, a) {},
            }),
            ke("stamped-launcher-opened", !0, 1)));
  }
  function z(t, a, i) {
    var n = t.search,
      d = t.customOptionTitle ? t.customOptionTitle + "||" + t.customOptionValue : "",
      o = t.topic,
      l = n || o || d,
      p = 1;
    d && (p = 2),
      o && (p = 3),
      s.ajax({
        type: "POST",
        url:
          r.SECURE_ENDPOINT +
          "/tracking/event?" +
          s.param({
            apiKey: e.StampedGlobalOptions.apiKey,
            sId: e.StampedGlobalOptions.sId,
            storeUrl: e.StampedGlobalOptions.storeUrl,
            event: "search",
            source: "m",
          }),
        data: JSON.stringify({ source: "m", sourceId: a, type: p, text: l, results: i }),
        contentType: "application/json; charset=utf-8",
        dataType: "json",
        success: function (e, t, a) {},
      });
  }
  function W(t) {
    s.ajax({
      type: "POST",
      url:
        r.SECURE_ENDPOINT +
        "/v2/rewards/points?" +
        s.param({
          apiKey: e.StampedGlobalOptions.apiKey,
          sId: e.StampedGlobalOptions.sId,
          storeUrl: e.StampedGlobalOptions.storeUrl,
        }),
      data: T.customer,
      dataType: "json",
      success: function (e, a, r) {
        setTimeout(function () {
          s(".stamped-rewards-header-main-points, .stamped-rewards-header-small-points", y).html(
            e.points_current_with_name
          );
        }, 5e3),
          t && t(e);
      },
    });
  }
  function M(t) {
    return (
      (t = t || {}),
      T || T.customer || console.log("Customer not logged in to create reward activity"),
      s.ajax({
        type: "POST",
        url:
          r.SECURE_ENDPOINT +
          "/v2/rewards/add?" +
          s.param({
            apiKey: e.StampedGlobalOptions.apiKey,
            sId: e.StampedGlobalOptions.sId,
            storeUrl: e.StampedGlobalOptions.storeUrl,
            campaignId: t.campaignId,
          }),
        data: T.customer,
        dataType: "json",
        success: function (e, a, s) {
          t.callback && t.callback(e, a, s), W(), Ye("stamped:rewards:earned", { detail: e });
        },
      })
    );
  }
  function $(e) {
    $wrapperCards.html(""), s("body", y).attr("data-view", e);
    for (var t = 0; t < T.html.cards.length; t++) {
      var a = T.html.cards[t];
      if (a && a.html && e == a.type) {
        var r = s(a.html);
        r.attr("data-key", a.key), $wrapperCards.append(r);
      }
    }
  }
  function V(t, a, i) {
    (c = s(".stamped-rewards-window", y)),
      s(".stamped-rewards-content-container", y).scrollTop(0),
      s(".stamped-rewards-header-nav", y).attr("onclick", "StampedFn.loadLauncherView('main');"),
      s("body", y).attr("data-view", t);
    var n = s(a).attr("data-title");
    if (c)
      if ("main" == t) {
        c.removeClass("stamped-rewards-nav-small"),
          c.addClass("stamped-rewards-nav-big"),
          s(".stamped-rewards-header-main, .stamped-rewards-header-menu", y).fadeIn(),
          s(".stamped-rewards-header-small", y).hide();
        var d = s(".stamped-rewards-header-content", y).outerHeight() + 15;
        s(".stamped-rewards-header", y).height(d),
          s(".stamped-rewards-background", y).height("200"),
          $wrapperViews.hide(),
          $wrapperCards.fadeIn();
      } else {
        var o = !1;
        if (i && 1 == i.reload) o = !1;
        else if ("view-redeem-variable" == t) o = !1;
        else
          for (var l = 0; l < T.html.views.length; l++) {
            var p = T.html.views[l];
            p.key == t && (p.title && (n = p.title), (o = !0), B(p.html), H(t, n, i));
          }
        if (!o) {
          B(), H(t, n, i);
          var m = null;
          i && i.entityId && (m = i.entityId);
          var u = r.is_test;
          s.ajax({
            type: "POST",
            url:
              r.SECURE_ENDPOINT +
              "/v2/rewards/cardview?" +
              s.param({
                apiKey: e.StampedGlobalOptions.apiKey,
                sId: e.StampedGlobalOptions.sId,
                storeUrl: e.StampedGlobalOptions.storeUrl,
                viewKey: t,
                entityId: m,
                referralCode: r.referral_code,
                isTest: u,
              }),
            data: T.customer,
            dataType: "json",
            success: function (e, a, s) {
              e && e.html
                ? (T.html.views.push(e),
                  setTimeout(function () {
                    B(e.html, !1), H(t, e.title || n, i);
                  }, 1e3))
                : V("main");
            },
            error: function () {
              V("main");
            },
          });
        }
      }
  }
  function B(e, t) {
    if (e) {
      var a = s(e);
      $wrapperViews.html(a), $wrapperViews.removeClass("loading");
    } else
      $wrapperViews.html(""),
        s(".stamped-view-loader", $wrapperViews).length ||
          $wrapperViews.append(s('<div class="stamped-view-loader"></div>')),
        $wrapperViews.addClass("loading");
    0 != t &&
      (c.addClass("stamped-rewards-nav-small"),
      c.removeClass("stamped-rewards-nav-big"),
      s(".stamped-rewards-header-main, .stamped-rewards-header-menu", y).hide(),
      s(".stamped-rewards-header-small", y).fadeIn(),
      $wrapperCards.hide(),
      $wrapperViews.fadeIn());
  }
  function H(e, t, a) {
    var r,
      i = (a ? a.viewTitle : t) || t;
    if (
      ("view-coupon" == e &&
        (s(".stamped-reward-coupon-code", $wrapperViews).text(a.couponCode),
        s(".stamped-reward-card-title", $wrapperViews).html(a.title),
        (function (e, t) {
          s(".stamped-rewards-header-nav", y).attr(
            "onclick",
            "StampedFn.loadLauncherView('" + e + "', null, { reload: " + (t || !1) + "});"
          );
        })("view-your-rewards", !0)),
      "view-earnings" == e && T && T.customer)
    ) {
      var n = s('[data-event-type="AccountBirthday"]', y);
      if (n.length)
        T.customer.dateBirthday
          ? n.attr("data-birthday", "true")
          : (n.attr("data-birthday", "false"),
            n.prepend(s(".stamped-rewards-birthday-input-holder", y)));
    }
    if ("view-redeem-variable" == e) {
      if ((($selectorInput = s(".range-slider__range", $wrapperViews)), $selectorInput.length)) {
        var d = $selectorInput.data("format-points"),
          o = $selectorInput.data("format-points-name"),
          l = $selectorInput.data("currency"),
          p = $selectorInput.attr("step"),
          c = $selectorInput.data("discount-value");
        function m() {
          var e = $selectorInput.val(),
            t = (e / p) * c,
            a = new Intl.NumberFormat("en-US", { style: "currency", currency: l });
          s("#redeem-points", $wrapperViews).text(d.formatStringStamped(e, o)),
            s("#redeem-amount", $wrapperViews).text(a.format(t));
        }
        $selectorInput.on("input", function () {
          m();
        }),
          s(".stamped-rewards-content-action-button ", $wrapperViews).on("click", function () {
            var e, t, r;
            (e = this),
              (t = $selectorInput.val()),
              (r = { campaignId: a.entityId, points: t }),
              StampedFn.rewardsRedeem(s(e), r, function (e) {
                var t = e.rewardCampaignCoupon.couponCode,
                  a = e.rewardCampaignCoupon.title;
                V("view-coupon", null, { couponCode: t, title: a, viewTitle: a });
              });
          }),
          m();
      }
    }
    i && ((r = i), s(".stamped-rewards-header-small-title", y).text(r));
  }
  function Q(t) {
    var a = (t = t || {}).campaignEventType;
    if ("AccountBirthday" == a)
      !(function (t) {
        (t = t || {}),
          s.ajax({
            type: "POST",
            url:
              r.SECURE_ENDPOINT +
              "/v2/rewards/addBirthday?" +
              s.param({
                apiKey: e.StampedGlobalOptions.apiKey,
                sId: e.StampedGlobalOptions.sId,
                storeUrl: e.StampedGlobalOptions.storeUrl,
                dateBirthday: t.birthday,
              }),
            data: T.customer,
            success: function (e, a, s) {
              t.callback && t.callback();
            },
          });
      })(t);
    else if (
      "SocialFollowInstagram" == a ||
      "SocialFollowFacebook" == a ||
      "SocialShareFacebook" == a ||
      "SocialFollowTwitter" == a ||
      "SocialShareTwitter" == a ||
      "SocialYouTube" == a ||
      "SocialFollowTiktok" == a ||
      "SocialShareTiktok" == a ||
      "SocialFollowPinterest" == a
    ) {
      M({ campaignId: t.campaignId, callback: t.callback });
      var i = T.links;
      if ("SocialFollowInstagram" == a) e.open(i.instagram, "_blank").focus();
      else if ("SocialFollowFacebook" == a)
        e.open(
          "https://www.facebook.com/plugins/page.php?href=" + i.facebook,
          "_blank",
          "location=yes,height=250,width=340,top=50,left=50,scrollbars=yes,status=yes"
        );
      else if ("SocialShareFacebook" == a)
        e.open(
          "https://www.facebook.com/sharer/sharer.php?u=" + i.shop,
          "_blank",
          "location=yes,height=500,width=500,top=50,left=50,scrollbars=yes,status=yes"
        );
      else if ("SocialFollowTwitter" == a) {
        e.open(i.twitter, "_blank").focus();
      } else
        "SocialShareTwitter" == a
          ? e.open(
              "https://twitter.com/intent/tweet?url=" + i.shop,
              "_blank",
              "location=yes,height=500,width=500,top=50,left=50,scrollbars=yes,status=yes"
            )
          : "SocialYouTube" == a
          ? e.open(i.youtube, "_blank")
          : "SocialFollowTiktok" == a || "SocialShareTiktok" == a
          ? e.open(i.tiktok, "_blank")
          : "SocialFollowPinterest" == a && e.open(i.pinterest, "_blank");
    }
  }
  function J(t) {
    !(function (t) {
      (t = t || {}),
        s.ajax({
          type: "POST",
          url:
            r.SECURE_ENDPOINT +
            "/v2/rewards/redeem?" +
            s.param({
              apiKey: e.StampedGlobalOptions.apiKey,
              sId: e.StampedGlobalOptions.sId,
              storeUrl: e.StampedGlobalOptions.storeUrl,
              campaignId: t.campaignId,
              points: t.points,
            }),
          data: T.customer,
          dataType: "json",
          success: function (e, a, s) {
            t.callback && t.callback(e), W(), Ye("stamped:rewards:redeemed", { detail: e });
          },
        });
    })({ campaignId: (t = t || {}).campaignId, callback: t.callback });
  }
  function Y(e) {
    var t = s("#stamped-rewards-apply-code", y);
    "active" == e && s(".stamped-rewards-coupons-view", y).attr("data-applied", "true"), X(t, e);
  }
  function X(e, t, a, s, r) {
    if ("loading" == t) {
      var i = e.width();
      e.attr("data-original-text", e.text()),
        e.addClass("stamped-button-disabled"),
        i >= 10 && e.width(i),
        e.html('<span class="stamped-button-icon stamped-button-loading"></span>');
    } else
      a || e.html('<span class="stamped-button-icon stamped-button-completed"></span>'),
        setTimeout(function () {
          var t = e.attr("data-original-text");
          e.html(t), e.removeClass("stamped-button-disabled"), e.width("auto"), r && r();
        }, s || 7878);
  }
  function Z() {
    qe("Func initWidgetType");
    var t = s(".stamped-container", o).attr("data-widget-style");
    if ("slider" == t) {
      qe((A = s(".stamped-reviews", o)), 1);
      var a = A && A.hasClass("slick-initialized");
      if ((qe("Func initWidgetType: var initialized:" + a, 1), a))
        A.slick("slickAdd", s(".stamped-reviews > .stamped-review")),
          s('.stamped-reviews [class*="stamped-review"]', o).length <= 0
            ? s("button.slick-arrow").hide()
            : s("button.slick-arrow").show();
      else
        Le("//cdn.stamped.io/cdn/js/slick.min.js", function () {
          A.slick(r.slick_options),
            A.on("afterChange", function (e, t, a) {
              if (s(".slick-next.slick-arrow").hasClass("slick-disabled")) {
                _lastSlide = a;
                var r = s(".stamped-pagination .next a");
                r.length && r.click();
              }
            });
        });
    } else if ("masonry" == t) {
      var i = {
        container: ".stamped-reviews",
        margin: { x: 15, y: 15 },
        breakAt: { 1500: 4, 1200: 3, 700: 2, 500: 2 },
        columns: 4,
      };
      e.macyInstanceConfig &&
        (e.macyInstanceConfig.breakAt && (i.breakAt = e.macyInstanceConfig.breakAt),
        e.macyInstanceConfig.columns && (i.columns = e.macyInstanceConfig.columns)),
        Le("//cdn.stamped.io/cdn/js/macy2.js", function () {
          (e.macyInstanceStamped = Macy(i)), Ye("stamped:macy:loaded");
        });
    }
    if (s(".stamped-sort-select").length) {
      var n = o.attr("data-sort") || s(".stamped-container", o).attr("data-widget-sort");
      if (n) {
        var d = s('.stamped-sort-select option[value="' + n + '"]');
        d.css("display") && "none" !== d.css("display") && s(".stamped-sort-select").val(n);
      }
    }
  }
  function ee(e) {
    (o && o.length && !e) || (o = s(I)), me();
  }
  function te() {
    qe("Creating Q&A"), he();
  }
  function ae() {
    !(function () {
      var a;
      qe("Loading Badges..."),
        (S = s(
          ".stamped-product-reviews-badge[data-id], .stamped-product-reviews-badge[data-product-id]"
        )).length &&
          (a = s.map(S, function (e) {
            if (
              !s.trim(s(e).html()) &&
              (s(e).attr("data-id") ||
                s(e).attr("data-product-id") ||
                s(e).attr("data-type") ||
                s(e).attr("data-product-type") ||
                s(e).attr("data-product-sku") ||
                s(e).attr("data-product-title"))
            )
              return {
                productId: s(e).attr("data-id") || s(e).attr("data-product-id"),
                productType: s(e).attr("data-product-type"),
                productSKU: s(e).attr("data-product-sku") || s(e).attr("data-product-sku2"),
                productTitle: s(e).attr("data-product-title"),
              };
          })) &&
          a.length &&
          s.ajax({
            type: "POST",
            dataType: "json",
            contentType: "application/json",
            url:
              r.SECURE_ENDPOINT +
              "/widget/badges" +
              (!0 === r.is_disable_cache_badge ? "?isUseCache=false" : ""),
            data: JSON.stringify({
              productIds: a,
              apiKey: e.StampedGlobalOptions.apiKey,
              sId: e.StampedGlobalOptions.sId,
              storeUrl: e.StampedGlobalOptions.storeUrl,
            }),
            success: function (e) {
              S.each(function (t) {
                var a = s(this).attr("data-id") || s(this).attr("data-product-id"),
                  r = s(this).attr("data-type"),
                  i = s.map(e, function (e, t) {
                    if (e.productId == a) return t;
                  })[0];
                i >= 0 && (!r || "review" == r)
                  ? s(this).html(e[i].badge)
                  : i >= 0 && "qna" == r && s(this).html(e[i].badgeqna);
              }),
                Ye("stamped:badges:loaded");
            },
            error: function (e) {},
          });
      s(
        ".stamped-product-reviews-badge[data-id].stamped-main-badge, .stamped-product-reviews-badge:first"
      ).length &&
        s(t).on(
          "click",
          ".stamped-product-reviews-badge[data-id].stamped-main-badge, .stamped-product-reviews-badge:first",
          function () {
            if ("qna" === s(this).attr("data-type")) {
              if (
                (s("#stamped-questions-placeholder").length
                  ? Te("#stamped-questions-placeholder")
                  : (ve(null, "questions"), Te(I)),
                s(".stamped-badge-caption[data-questions]").length)
              ) {
                var e = s(".stamped-badge-caption[data-questions]").attr("data-questions");
                "0" === e && s(".new-question-form").show();
              }
            } else ve(null, "reviews"), Te(I);
          }
        );
    })();
  }
  function se() {
    var e = s("#stamped-reviews-widget").length;
    if ((qe("Creating display widgets " + e + " found"), Ye("stamped:widget:reloading"), e > 0)) {
      var t = [],
        a = 1;
      s("[id=stamped-reviews-widget]").each(function (e) {
        var r = s(this);
        r.attr("data-element-id", a);
        var i = ye(r);
        t.push(i), a++;
      }),
        be("ugc", t);
    }
  }
  function re() {
    var e = T;
    if (e.points) {
      var t = e.points.points;
      s("[id=stamped-rewards-points-placeholder]").attr(
        "onclick",
        "StampedFn.toggleRewardsModal();"
      ),
        s("[id=stamped-rewards-points-placeholder]").html(e.points.points_current_with_name),
        s('[id=stamped-rewards-points-placeholder][data-type="points-only"]').html(t),
        e.customer && s("[id=stamped-rewards-viptier-placeholder]").html(e.customer.vipTierTitle);
      var a = s('[id=stamped-rewards-points-placeholder][data-type="points-price"]');
      if (a.length && t >= 0) {
        var r,
          i = a.attr("data-ratio"),
          n = a.attr("data-symbol");
        if (i) if (parseInt(i)) (r = t > 0 ? (t / i).toFixed(2) : 0), a.html(n + r);
      }
    }
    if (
      (e.customer && s("[id=stamped-rewards-referral-placeholder]").html(e.customer.urlReferral),
      s("#stamped-rewards-widget").length > 0)
    ) {
      var d = [],
        o = 1;
      s("[id=stamped-rewards-widget]").each(function (e) {
        var t = s(this);
        t.attr("data-element-id", o);
        var a = ye(t);
        d.push(a), o++;
      }),
        be("rewards", d);
    }
  }
  function ie() {
    var e =
        s(o).attr("data-limit-words") || s(".stamped-container", o).attr("data-widget-limit-words"),
      t = s(o).attr("data-keyword"),
      a = s(o).attr("data-search");
    ((e && e > 0) || t || a) &&
      s(".stamped-review", o).each(function (r) {
        var i = s(".stamped-review-content-body:first", this);
        if (i.length) {
          var n = s(i).html();
          if (n.indexOf("stamped-review-read-more") <= -1)
            if (t || a) {
              var d;
              t && (d = ue(n, t)), a && (d = ue(n, a)), s(i).html(d);
            } else {
              var o = n.split(" ");
              o.length > e &&
                ((txtTrimmed = o.slice(0, e).join(" ") + "..."),
                s(i).html(txtTrimmed),
                s(i).append(
                  '<a class="stamped-review-read-more" style="margin-left:10px; cursor:pointer;">read more</span>'
                ),
                s(i).append(
                  '<span class="original-review" style="display:none !important;">' + n + "</span>"
                ));
            }
        }
      }),
      s(
        ".stamped-review-reply .stamped-review-reply-body, .stamped-review-reply .stamped-review-content-body"
      ).each(function () {
        if (!s(this).attr("data-link-processed")) {
          s(this).attr("data-link-processed", !0);
          var e = s(this).html();
          s(this).html(e.linkify());
        }
      });
  }
  function ne() {
    var e = s(o).attr("data-keywords");
    if (e) {
      s(".stamped-reviews-filter-label").show(),
        s(".stamped-summary-keywords").show(),
        s(o).removeAttr("data-keywords"),
        s(".stamped-summary-keywords-list", o).html("");
      var t = "",
        a = e.split(",");
      for (i = 0; i < a.length; i++) t += "<li>" + a[i] + "</li>";
      s(t).appendTo(s(".stamped-summary-keywords-list", o));
    }
  }
  function de() {
    s(t).on("click keypress", ".stamped-review-read-more", function (t) {
      if (!0 === E(t)) {
        s(this).closest(".stamped-review-content-body").find(".stamped-review-read-more").hide();
        var a = s(this).closest(".stamped-review-content-body").find(".original-review").html();
        s(this).closest(".stamped-review-content-body").html(a),
          e.macyInstanceStamped && e.macyInstanceStamped.reInit();
      }
    });
  }
  function oe() {
    s(".stamped-summary-ratings").removeClass("selected"),
      s(".stamped-summary-ratings .summary-rating").each(function () {
        s(this).removeClass("selected");
      }),
      s(".summary-rating-bar").each(function () {
        s(this).removeClass("selected");
      });
  }
  (F = void 0 !== e ? e : this),
    (N = function () {
      function e(e) {
        return e instanceof Date
          ? e
          : isNaN(e)
          ? /^\d+$/.test(e)
            ? new Date(t(e))
            : ((e = (e || "")
                .trim()
                .replace(/\.\d+/, "")
                .replace(/-/, "/")
                .replace(/-/, "/")
                .replace(/(\d)T(\d)/, "$1 $2")
                .replace(/Z/, " UTC")
                .replace(/([\+\-]\d\d)\:?(\d\d)/, " $1$2")),
              new Date(e))
          : new Date(t(e));
      }
      function t(e) {
        return parseInt(e);
      }
      function a(e, a, s) {
        a = p[a] ? a : p[s] ? s : "en";
        for (var r = 0, i = e < 0 ? 1 : 0, n = (e = Math.abs(e)); e >= c[r] && r < m; r++)
          e /= c[r];
        return (e = t(e)) > (0 === (r *= 2) ? 9 : 1) && (r += 1), p[a](e, r, n)[i].replace("%s", e);
      }
      function s(t, a) {
        return ((a = a ? e(a) : new Date()) - e(t)) / 1e3;
      }
      function r(e) {
        return e.dataset.timeagoStamped ? e.dataset.timeagoStamped : i(e, u);
      }
      function i(e, t) {
        return e.getAttribute ? e.getAttribute(t) : e.attr ? e.attr(t) : void 0;
      }
      function n(e, t) {
        (this.nowDate = e), (this.defaultLocale = t || "en");
      }
      function d(e, t) {
        return new n(e, t);
      }
      var o = "second_minute_hour_day_week_month_month".split("_"),
        l = "".split("_"),
        p = {
          en: function (e, t) {
            if (0 === t) return ["just now", "right now"];
            var a = o[parseInt(t / 2)];
            return e > 1 && (a += "s"), [e + " " + a + " ago", "in " + e + " " + a];
          },
          zh_CN: function (e, t) {
            if (0 === t) return ["", ""];
            var a = l[parseInt(t / 2)];
            return [e + a + "", e + a + ""];
          },
        },
        c = [60, 60, 24, 7, 365 / 7 / 12, 1],
        m = 6,
        u = "datetime",
        h = "data-tid",
        v = {};
      return (
        (n.prototype.doRender = function (e, t, r) {
          var i,
            n = s(t, this.nowDate),
            d = this;
          (e.innerHTML = a(n, r, this.defaultLocale)),
            (v[
              (i = setTimeout(
                function () {
                  d.doRender(e, t, r), delete v[i];
                },
                Math.min(
                  1e3 *
                    (function (e) {
                      for (var t = 1, a = 0, s = Math.abs(e); e >= c[a] && a < m; a++)
                        (e /= c[a]), (t *= c[a]);
                      return (s = (s %= t) ? t - s : t), Math.ceil(s);
                    })(n),
                  2147483647
                )
              ))
            ] = 0),
            (function (e, t) {
              e.setAttribute ? e.setAttribute(h, t) : e.attr && e.attr(h, t);
            })(e, i);
        }),
        (n.prototype.formatDateString = function (e, t) {
          return a(s(e, this.nowDate), t, this.defaultLocale);
        }),
        (n.prototype.render = function (e, t) {
          void 0 === e.length && (e = [e]);
          for (var a = 0, s = e.length; a < s; a++) this.doRender(e[a], r(e[a]), t);
        }),
        (n.prototype.setLocale = function (e) {
          this.defaultLocale = e;
        }),
        (d.register = function (e, t) {
          p[e] = t;
        }),
        (d.cancel = function (e) {
          var t;
          if (e)
            (t = (function (e) {
              return i(e, h);
            })(e)) && (clearTimeout(t), delete v[t]);
          else {
            for (t in v) clearTimeout(t);
            v = {};
          }
        }),
        d
      );
    }),
    "object" == typeof module && module.exports
      ? ((module.exports = N()), (module.exports.default = module.exports))
      : (F.timeagoStamped = N());
  var le = 0;
  function pe() {
    if (e.File && e.FileReader && e.FormData) {
      var a = s("#stamped-file-uploader-input");
      a.on("change", function (e) {
        for (var i = e.target.files, n = 0; n < i.length; n++) {
          var d = i[n],
            o = new FileReader();
          if ((Ye("stamped:photo:selected"), le >= 5)) return void Ye("stamped:photo:maxed");
          if ((le++, d.type.match("image"))) r(d, le);
          else {
            if (d.size / 1024 / 1024 > 50)
              return (
                Ye("stamped:photo:sizeError"),
                void alert(
                  "Sorry, you cannot add this video to your review. Up to 50mb is allowed."
                )
              );
            (o.onload = function () {
              var e = new Blob([o.result], { type: d.type }),
                a = URL.createObjectURL(e),
                r = t.createElement("video"),
                i =
                  '<div class="stamped-file-photo" data-index="' +
                  le +
                  '"><img src="https://s3-us-west-2.amazonaws.com/stamped.io/cdn/images/icons/icon-video-placeholder.png" width="70" /><span style="display:none;">' +
                  d.name +
                  '</span><div class="stamped-file-photo-remove" data-index="' +
                  le +
                  '">x</div></div>',
                n = function () {
                  l() && (r.removeEventListener("timeupdate", n), r.pause());
                };
              r.addEventListener("loadeddata", function () {
                l() ? r.removeEventListener("timeupdate", n) : s(".stamped-file-holder").append(i),
                  k.push(d);
              });
              var l = function () {
                var e = t.createElement("canvas");
                (e.width = r.videoWidth),
                  (e.height = r.videoHeight),
                  e.getContext("2d").drawImage(r, 0, 0, e.width, e.height);
                var i = e.toDataURL(),
                  n = i.length > 1e5;
                return (
                  n &&
                    (s(".stamped-file-holder").append(
                      '<div class="stamped-file-photo" data-index="' +
                        le +
                        '"><img src="' +
                        i +
                        '" width="70" /><span style="display:none;">' +
                        d.name +
                        '</span><div class="stamped-file-photo-remove" data-index="' +
                        le +
                        '">x</div></div>'
                    ),
                    URL.revokeObjectURL(a)),
                  n
                );
              };
              r.addEventListener("timeupdate", n),
                (r.preload = "metadata"),
                (r.src = a),
                (r.muted = !0),
                (r.playsInline = !0),
                r.play();
            }),
              o.readAsArrayBuffer(d);
          }
          d &&
            (/^image\//i.test(d.type) || /^video\//i.test(d.type)
              ? console.log("is image, begin upload")
              : (Ye("stamped:photo:invalid"), console.log("Not a valid image!")));
        }
        a.val("");
      }),
        s(t).on("click", ".stamped-file-photo-remove", function () {
          var e = s(this).parent(".stamped-file-photo"),
            t = e.index();
          k.splice(t, 1), (le = k.length), e.remove();
        });
    } else console.log("File upload is not supported!");
    function r(e, t) {
      !(function (e, t) {
        var a = new FileReader();
        (a.onload = function (e) {
          var a = new DataView(e.target.result);
          if (65496 != a.getUint16(0, !1)) return t(-2);
          for (var s = a.byteLength, r = 2; r < s; ) {
            var i = a.getUint16(r, !1);
            if (((r += 2), 65505 == i)) {
              if (1165519206 != a.getUint32((r += 2), !1)) return t(-1);
              var n = 18761 == a.getUint16((r += 6), !1);
              r += a.getUint32(r + 4, n);
              var d = a.getUint16(r, n);
              r += 2;
              for (var o = 0; o < d; o++)
                if (274 == a.getUint16(r + 12 * o, n)) return t(a.getUint16(r + 12 * o + 8, n));
            } else {
              if (65280 != (65280 & i)) break;
              r += a.getUint16(r, !1);
            }
          }
          return t(-1);
        }),
          a.readAsArrayBuffer(e.slice(0, 65536));
      })(e, function (e) {
        e;
      });
      var a = new FileReader();
      (a.onloadend = function () {
        var r, n, d, o;
        (r = a.result),
          e.type,
          (n = e.name),
          (d = t),
          ((o = new Image()).src = r),
          (o.onload = (function (e, t, a) {
            setTimeout(function () {
              o.width,
                o.height,
                s(".stamped-file-holder").append(
                  '<div class="stamped-file-photo" data-index="' +
                    e +
                    '"><img src="' +
                    r +
                    '" width="70" /><span style="display:none;">' +
                    a +
                    '</span><div class="stamped-file-photo-remove" data-index="' +
                    e +
                    '">x</div></div>'
                ),
                i(r, e, a);
            }, 100);
          })(d, 0, n)),
          (o.onerror = function () {
            console.log("There was an error processing your file!");
          });
      }),
        (a.onerror = function () {
          console.log("There was an error reading the file!");
        }),
        a.readAsDataURL(e);
    }
    function i(e, t, a) {
      var s = (function (e, t) {
        for (
          var a = e.split(","),
            s = a[0].match(/:(.*?);/)[1],
            r = atob(a[1]),
            i = r.length,
            n = new Uint8Array(i);
          i--;

        )
          n[i] = r.charCodeAt(i);
        return new File([n], t, { type: s });
      })(e, a);
      k.push(s);
    }
  }
  var ce = null;
  function me(t, a, i, d) {
    if (o.length && !n) {
      qe("Loading Main Widget...");
      var l = o.attr("data-product-id"),
        p = o.attr("data-product-ids"),
        c = o.attr("data-name"),
        m = o.attr("data-product-type"),
        u = o.attr("data-product-sku") || o.attr("data-product-sku2"),
        h = o.attr("data-user-reference"),
        v = o.attr("data-take-reviews"),
        g = o.attr("data-keyword"),
        f = o.attr("data-widget-language"),
        w = o.attr("data-widget-country-iso"),
        y = o.attr("data-widget-type"),
        b = o.attr("data-load-type") || s(".stamped-container", o).attr("data-widget-load-type"),
        S = o.attr("data-search"),
        k = o.attr("data-cache") || r.is_disable_cache || null,
        _ = s(".stamped-container", o).attr("data-widget-style"),
        I = o.attr("data-tags-exclude"),
        T = o.attr("data-tags-include"),
        O = r.metafields;
      "slider" == _ && (b = "continue"),
        c && (c = c.replace("!", "")),
        a || (a = o.attr("data-sort") || s(".stamped-container", o).attr("data-widget-sort")),
        "continue" === b && (d = !0),
        s("#stamped-main-widget-placeholder").length &&
          s("#stamped-main-widget-placeholder").append(o),
        (n = !0),
        t && !d && Te(".stamped-reviews"),
        o.addClass("stamped-main-widget-loading");
      var x = s("<span>Loading more...</span>").prependTo(s("#stamped-reviews-tab")),
        E = s.param(
          Ce({
            productId: l,
            productIds: p,
            productName: c,
            productType: m,
            productSKU: u,
            userReference: h,
            page: t || 1,
            apiKey: e.StampedGlobalOptions.apiKey,
            sId: e.StampedGlobalOptions.sId,
            storeUrl: e.StampedGlobalOptions.storeUrl,
            take: v || 5,
            sort: a,
            rating: i,
            keyword: g,
            widgetLanguage: f,
            widgetCountryIso: w,
            widgetType: y,
            search: S,
            isUseCache: k,
            tagsExclude: I,
            tagsInclude: T,
          })
        );
      s.isEmptyObject(C) || (E += "&" + s.param(C));
      var U = O.length,
        R = {
          type: U ? "POST" : "GET",
          data: U ? JSON.stringify({ metafields: O }) : null,
          dataType: "json",
          url: r.SECURE_ENDPOINT + "/widget" + (U ? "/preview" : "") + "?" + E,
          success: function (e) {
            qe("Loaded Main Widget..."),
              (n = !1),
              o.removeClass("stamped-main-widget-loading"),
              x.remove();
            var r,
              i = e.product,
              d = e.widget,
              p = s("#stamped-main-widget .stamped-container").length;
            s(".question-form-wrapper").clone(), s(".stamped-questions").clone();
            if (
              (p || o.empty().html(i),
              (r = "function" == typeof s.parseHTML ? s.parseHTML(d) : s(d)),
              0 == s(".stamped-content", o).children().length)
            )
              s(".stamped-content", o).append(s(r));
            else {
              var c = s(".stamped-reviews", o),
                m = s('[class="stamped-review"]', r);
              ("continue" !== b || (null === t && void 0 === t) || (1 === t && t)) &&
                s('.stamped-reviews [class*="stamped-review"]', o).remove();
              var u = s(".stamped-pagination", r).attr("data-page", t),
                h = s(".stamped-reviews .stamped-pagination", o);
              h.length ? s(m).insertBefore(h) : s(m).appendTo(".stamped-reviews", o);
              var v = s(".stamped-tabs", r);
              s(".stamped-tabs", o).replaceWith(v),
                u.length ? (h.length ? h.replaceWith(u) : c.append(u)) : h.remove();
            }
            a &&
              s(".stamped-sort-select", o).length &&
              "none" !== s('.stamped-sort-select option[value="' + a + '"]', o).css("display") &&
              (s(".stamped-sort-select", o).val(a),
              s(".stamped-container", o).attr("data-widget-sort", a),
              s(o).attr("data-sort", a)),
              s(".new-review-form").hide(),
              s(".new-question-form").hide(),
              Ye("stamped:reviews:loaded"),
              s(".stamped-summary-actions-newreview").attr(
                "aria-controls",
                "new-review-form_" + (null != l ? l : "")
              ),
              Array.prototype.slice.call(s(".stamped-pagination > li")).forEach(function (e) {
                e.classList.contains("active")
                  ? e.children[0].setAttribute("aria-current", "page")
                  : e.removeAttribute("aria-current");
              });
          },
          error: function (e) {},
        };
      O.length && (R.contentType = "application/json"), null != ce && ce.abort(), (ce = s.ajax(R));
    }
    g && z({ topic: g }, l), S && z({ search: S }, l);
  }
  function ue(e, t) {
    return (e = e.replace(
      new RegExp(t + "(?!([^<]+)?<)", "gi"),
      '<span class="stamped-keyword-highlight">$&</span>'
    ));
  }
  function he(t, a) {
    if ((o = s(I)).length) {
      var i = o.attr("data-product-id"),
        n = o.attr("data-product-sku"),
        d = o.attr("data-product-type"),
        l = o.attr("data-name"),
        p = o.attr("data-take-questions") || 5,
        c = o.attr("data-search-qna");
      a || (a = o.attr("data-sort-qna") || s(".stamped-container", o).attr("data-widget-sort-qna"));
      var m = o.data("linkify") || !1;
      if (!i) return;
      qe("Loading Q&A"),
        s.ajax({
          type: "GET",
          url: r.SECURE_ENDPOINT + "/widget/questions",
          data: {
            productId: i,
            productSKU: n,
            productType: d,
            productTitle: l,
            page: t || 1,
            apiKey: e.StampedGlobalOptions.apiKey,
            sId: e.StampedGlobalOptions.sId,
            storeUrl: e.StampedGlobalOptions.storeUrl,
            take: p || 5,
            search: c,
            sort: a,
          },
          success: function (e) {
            if (1 == e.a && s(".stamped-questions").length) {
              var r, i, n, d;
              (r = e.result), (i = e.t), (n = e.form), e.p, (d = e.avatar);
              s("#tab-questions").text();
              s("#tab-questions").attr("data-count", i),
                (function (e) {
                  if (s(".stamped-questions").length && !s(".question-form-wrapper").length) {
                    var t = s('<div class="question-form-wrapper">').html(e);
                    s(".new-review-form").before(t);
                  }
                })(n);
              var o = s(
                '<div id="stamped-questions-tab" class="stamped-questions" role="tabpanel" aria-labelledby="tab-questions" tabindex="-1">'
              );
              if ((s(".stamped-questions").html(""), o.append(r), d)) {
                var l = s(".stamped-review #stamped-review-avatar", o),
                  c = s('<img src="' + d + '" width="100">');
                l.html(c);
              }
              var u = s(".stamped-questions-placeholder");
              u.length
                ? (s(".stamped-questions", u).html(""),
                  s(".stamped-questions", u).replaceWith(o),
                  s(".stamped-questions", u).length ||
                    (s(".stamped-questions").appendTo(u), s(".stamped-questions").replaceWith(o)),
                  s(".stamped-questions", u).show(),
                  s("#tab-questions").hide(),
                  s(".question-form-wrapper").prependTo(u),
                  s(".stamped-summary-actions-newquestion").prependTo(u))
                : (s(".stamped-questions").replaceWith(o),
                  t ? s(".stamped-questions").show() : s(".stamped-questions").hide()),
                (function (e, t, a) {
                  var r = e > 0 ? (e / a < 1 ? 1 : Math.ceil(e / a)) : 1;
                  if (1 == r) return;
                  var i =
                      '<div class="stamped-pagination" id="stamped-pagination-question"><div><span id="stamped-pagination-prev" class="previous"><a href="#" onclick="StampedFn.pageQuestions(this)" role="link" tabindex="0" data-product-id="" data-page="' +
                      (t - 1) +
                      '"><</a></span><span id="pages"></span><span id="stamped-pagination-next" class="next"><a onclick="StampedFn.pageQuestions(this)" role="link" tabindex="0" data-product-id="" data-page="' +
                      (t + 1) +
                      '">></a></span></div></div>',
                    n = s(".stamped-questions"),
                    d = s(".stamped-questions-placeholder");
                  d.length && (n = s(".stamped-questions", d));
                  var o = s(".stamped-pagination", n);
                  o.length ? o.replaceWith(i) : n.append(i);
                  o = s(".stamped-pagination", n);
                  var e = r,
                    t = t,
                    l = [];
                  if ((l.push(1), e <= 7)) {
                    for (m = 2; m < e; m++) l.push(m);
                    e == t && l.push(t);
                  }
                  if (e >= 8) {
                    var p = t - 2;
                    p >= 1 && (t - 2 != 1 && l.push(t - 2), l.push(t - 1)), 1 != t && l.push(t);
                    var c = t + 2;
                    c <= e && (l.push(t + 1), c != e && l.push(t + 2));
                  }
                  1 == t || 1 == t
                    ? s("#stamped-pagination-prev", o).hide()
                    : s("#stamped-pagination-prev", o).show();
                  e == t || 1 == e
                    ? s("#stamped-pagination-next", o).hide()
                    : s("#stamped-pagination-next", o).show();
                  e != t && l.push(e);
                  for (var m = 0; m < l.length; m++) {
                    var u = l[m] == t;
                    u
                      ? s("#pages", o).append(
                          ' <span class="page active"><a style="cursor:pointer;" onclick="StampedFn.pageQuestions(this)" role="button" tabindex="0" data-product-id="" data-page="' +
                            l[m] +
                            '">' +
                            l[m] +
                            "</a></span> "
                        )
                      : s("#pages", o).append(
                          ' <span class="page"><a style="cursor:pointer;" onclick="StampedFn.pageQuestions(this)" role="button" tabindex="0" data-product-id="" data-page="' +
                            l[m] +
                            '">' +
                            l[m] +
                            "</a></span> "
                        );
                  }
                })(i, t || 1, p),
                u.length ? t > 1 && Te(".stamped-questions-placeholder") : t > 1 && Te(I),
                a || s(".stamped-questions-filter .stamped-sort-select").val("recent"),
                m &&
                  s(".stamped-review-reply-body", o).each(function () {
                    if (!s(this).attr("data-link-processed")) {
                      s(this).attr("data-link-processed", !0);
                      var e = s(this).html();
                      s(this).html(e.linkify());
                    }
                  }),
                Ye("stamped:questions:loaded");
            }
          },
        });
    }
  }
  function ve(e, t) {
    s("#stamped-questions-placeholder, .stamped-questions-placeholder").length ||
      (s(".stamped-tabs #tab-reviews").removeClass("active"),
      s(".stamped-tabs #tab-questions").removeClass("active"),
      "questions" == t
        ? s(".stamped-tabs #tab-questions").addClass("active")
        : "reviews" == t && s(".stamped-tabs #tab-reviews").addClass("active"),
      e && (s(e).addClass("active"), (t = s(e).data("type"))),
      "reviews" == t
        ? (s(".stamped-reviews").show(),
          s(".stamped-reviews-filter").show(),
          s(".stamped-questions").hide(),
          s(".stamped-questions-filter").hide(),
          s(".stamped-reviews").attr("tabindex", 0),
          s(".stamped-questions").attr("tabindex", -1),
          s("#stamped-sort-select").show())
        : "questions" == t &&
          (s(".stamped-reviews").hide(),
          s(".stamped-reviews-filter").hide(),
          s(".stamped-questions").show(),
          s(".stamped-questions-filter").show(),
          s(".stamped-reviews").attr("tabindex", -1),
          s(".stamped-questions").attr("tabindex", 0),
          s("#stamped-sort-select").hide()),
      s(".new-review-form").hide(),
      s(".new-question-form").hide());
  }
  function ge(e, t) {
    var a = [];
    for (i = 0; i < e.length; i++) {
      var s = e[i];
      if (1 != t || s.reviewUserPhotos || s.reviewUserVideos) {
        var r = {
          photos: [],
          videos: [],
          name: s.author,
          via: "Photos",
          title: s.reviewTitle,
          body: s.reviewMessage,
          date: s.reviewDate,
          reply: s.reviewReply,
          dateReplied: s.dateReplied,
          dateFull: s.dateCreated,
          verifiedType: s.reviewVerifiedType,
          rating: s.reviewRating,
          products: [
            {
              url: s.productUrl,
              title: s.productName,
              imageUrl: s.productImageUrl,
              imageLargeUrl: s.productImageLargeUrl,
              productUrl: s.productDirectUrl || "",
            },
          ],
          review_id: s.id,
          votes: { up: s.reviewVotesUp, down: s.reviewVotesDown },
          options: [],
        };
        if (s.reviewUserPhotos || s.reviewUserVideos) {
          if (s.reviewUserVideos) {
            var n = s.reviewUserVideos.split(",");
            for (ii = 0; ii < n.length; ii++) {
              var d = "//s3.us-west-2.amazonaws.com/stamped.io/uploads/videos/" + n[ii],
                o = "//cdn.stamped.io/uploads/videos/" + n[ii] + ".jpg";
              d.indexOf(".mp4") < 0 && (d += ".mp4"),
                d.indexOf("nothumb") >= 0 && (o = ""),
                r.photos.push({ videoUrl: d, imageThumbnailUrl: o });
            }
          }
          if (s.reviewUserPhotos) {
            var l = s.reviewUserPhotos.split(","),
              p = "//cdn.stamped.io/uploads/photos/";
            for (
              s.reviewUserPhotosWatermark &&
                (p = "//cdn.stamped.io/" + s.reviewUserPhotosWatermark + "/uploads/photos/"),
                ii = 0;
              ii < l.length;
              ii++
            )
              r.photos.push({
                imageUrl: p + l[ii],
                imageThumbnailUrl: "//cdn.stamped.io/uploads/photos/thumb/" + l[ii],
              });
          }
        } else
          r.photos.push({ imageUrl: s.productImageLargeUrl, imageThumbnailUrl: s.productImageUrl });
        if (s.reviewOptionsList && s.reviewOptionsList.length)
          for (ii = 0; ii < s.reviewOptionsList.length; ii++)
            r.options.push({
              message: s.reviewOptionsList[ii].message,
              value: s.reviewOptionsList[ii].value,
            });
        a.push(r);
      }
    }
    return a;
  }
  var fe = [],
    we = !1;
  function ye(t, a) {
    var i = s(t),
      n = i.attr("data-element-id"),
      d = i.attr("data-widget-type"),
      o = (i.attr("data-widget-persist-data"), i.attr("data-review-id")),
      l = i.attr("data-review-ids") ? i.attr("data-review-ids").toString().split(",") : null,
      p = i.attr("data-product-id"),
      c = i.attr("data-product-ids") ? i.attr("data-product-ids").toString().split(",") : null,
      m = i.attr("data-product-category") || i.attr("data-product-type"),
      u = i.attr("data-product-brand"),
      h = i.attr("data-product-sku"),
      v = (i.attr("data-product-title"), i.attr("data-limit-words")),
      g = i.attr("data-random"),
      f = i.attr("data-show-avatar"),
      w = i.attr("data-take"),
      y = i.attr("data-fill-empty"),
      b = i.attr("data-min-rating"),
      S = i.attr("data-min-length"),
      k = i.attr("data-rating"),
      _ = i.attr("data-tags"),
      C = i.attr("data-tags-exclude"),
      I = i.attr("data-topic"),
      T = i.attr("data-syndication") || !0,
      O = i.data("with-photos"),
      x = i.data("with-videos"),
      E = i.data("sort-reviews"),
      U = i.data("widget-data"),
      R = i.data("widget-language"),
      F = i.data("widget-country-iso"),
      N = i.data("instagram-gallery-id"),
      A = i.data("album-id"),
      j = i.data("customer-email"),
      q = i.data("customer-first-name"),
      L = i.data("customer-id"),
      G = d.indexOf("rewards") > -1 ? r.referral_code : null,
      P = i.data("is-preview");
    return {
      type: d,
      reviewId: o,
      reviewIds: l,
      productId: p,
      productIds: c,
      productCategory: m,
      productBrand: u,
      productSKU: h,
      limitWords: v,
      random: g,
      showAvatar: f,
      isFillEmpty: y,
      apiKey: e.StampedGlobalOptions.apiKey,
      sId: e.StampedGlobalOptions.sId,
      storeUrl: e.StampedGlobalOptions.storeUrl,
      page: a,
      skip: w,
      minRating: b,
      minLength: S,
      rating: k,
      isWithPhotos: O,
      isWithVideos: x,
      sortReviews: E,
      instagramGalleryId: N,
      albumId: A,
      dataType: U,
      widgetLanguage: R,
      widgetCountryIso: F,
      tags: _,
      tagsExclude: C,
      topic: I,
      isSyndication: T,
      elementId: n,
      customerEmail: j,
      customerFirstName: q,
      customerExternalId: L,
      referralCode: G,
      isPreview: P,
    };
  }
  function be(e, t) {
    var a = r.SECURE_ENDPOINT + "/widget/reviews/batch";
    s.ajax({
      type: "POST",
      dataType: "json",
      contentType: "application/json",
      data: JSON.stringify({ data: t }),
      xhrFields: { withCredentials: !0 },
      url: a,
      success: function (t, a, r) {
        for (var i = t.length, n = 100, d = 0; d < i; d++)
          if (t[d]) {
            n += 50;
            var o = t[d].elementId;
            Se(
              s(
                "rewards" == e
                  ? '#stamped-rewards-widget[data-element-id="' + o + '"]'
                  : '#stamped-reviews-widget[data-element-id="' + o + '"]'
              ),
              t[d],
              t.translations,
              n
            );
          }
      },
    });
  }
  function Se(a, r, i, n) {
    setTimeout(function () {
      if (r) {
        var i = r.template,
          n = r.lang,
          d = a.attr("data-widget-type"),
          o = a.data("widget-persist-data") || !1;
        if (
          (s(a).attr("data-lang", n || "en"),
          "instagram-feed" != d &&
            "instagram-feed-dev" != d &&
            "visual-gallery" != d &&
            1 != o &&
            s(a).html(""),
          "single" == d)
        )
          a.append(i), StampedWidgetSingleFn, StampedWidgetSingleFn.init(r.data, a, s);
        else if ("full-page" == d || "full-page-nps" == d) {
          var l = a.attr("data-rich-snippet"),
            p = "/" == location.pathname;
          if (r.total > 0 && "true" == l && !p) {
            var c = {
                "@context": "http://schema.org",
                "@type": "Product",
                name: r.shop,
                aggregateRating: {
                  "@type": "AggregateRating",
                  ratingValue: r.rating,
                  reviewCount: r.total,
                },
              },
              m = t.createElement("script");
            (m.type = "application/ld+json"),
              (m.innerHTML = JSON.stringify(c)),
              t.getElementsByTagName("head")[0].appendChild(m);
          }
          a.append(i), StampedWidgetFullPageFn, StampedWidgetFullPageFn.init(r, a, s);
        } else
          "full-page-multiple" == d
            ? (a.append(i),
              StampedWidgetFullPageMultipleFn,
              StampedWidgetFullPageMultipleFn.init(r, a, s))
            : "reviews-highlight" == d
            ? (a.append(i),
              StampedWidgetReviewsHighlightFn,
              StampedWidgetReviewsHighlightFn.init(r, a, s))
            : "reviews-popup" == d
            ? (a.append(i), StampedWidgetReviewsPopupFn, StampedWidgetReviewsPopupFn.init(r, a, s))
            : "people-highlight" == d
            ? (a.append(i),
              StampedWidgetPeopleHighlightFn,
              StampedWidgetPeopleHighlightFn.init(r, a, s))
            : "drawer" == d
            ? (a.append(i), StampedWidgetDrawerFn, StampedWidgetDrawerFn.init(r, a, s))
            : "carousel" == d
            ? (a.append(i), StampedCarouselFn, StampedCarouselFn.init(r, a, s))
            : "carousel-nps" == d
            ? (a.append(i), StampedCarouselNPSFn, StampedCarouselNPSFn.init(r, a, s))
            : "carousel-checkout-comments" == d
            ? (a.append(i),
              StampedCarouselCheckoutCommentFn,
              StampedCarouselCheckoutCommentFn.init(r, a, s))
            : "carousel-photos" == d
            ? (a.append(i), StampedCarouselPhotosFn, StampedCarouselPhotosFn.init(r.data, a, s))
            : "site-badge" == d
            ? (a.append(i), StampedSiteBadgeFn, StampedSiteBadgeFn.init(r, a, s))
            : "top-rated" == d
            ? (a.append(i), StampedTopRatedFn, StampedTopRatedFn.init(r, a, s))
            : "wall-photos" == d
            ? (a.append(i), StampedWallPhotosFn, StampedWallPhotosFn.init(r, a, s))
            : "checkout-comments" == d
            ? (a.append(i), StampedCheckoutCommentsFn, StampedCheckoutCommentsFn.init(r, a, s))
            : "instagram-feed" == d
            ? (s(a).is(":empty") && a.append(i),
              StampedInstagramFeedFn,
              StampedInstagramFeedFn.init(r, a, s))
            : "visual-gallery" == d
            ? (e.stampedVisualGalleryDataArr || a.append(i),
              StampedVisualGalleryFeedFn,
              StampedVisualGalleryFeedFn.init(r, a, s))
            : "facebook-messenger-optin" == d
            ? (StampedFacebookMessengerOptinFn, StampedFacebookMessengerOptinFn.init(r, a, s))
            : "nps-submission-form" == d
            ? (a.append(i), StampedNPSSubmissionForm, StampedNPSSubmissionForm.init(r, a, s))
            : "rewards-summary" == d
            ? (a.append(i), StampedRewardsSummary, StampedRewardsSummary.init(r, a, s))
            : "rewards-how-it-works" == d
            ? (a.append(i), StampedRewardsHowItWorks, StampedRewardsHowItWorks.init(r, a, s))
            : "rewards-referral-modal" == d
            ? (a.append(i), StampedRewardsReferralModal, StampedRewardsReferralModal.init(r, a, s))
            : "rewards-referral-claim-modal" == d
            ? (a.append(i),
              StampedRewardsReferralClaimModal,
              StampedRewardsReferralClaimModal.init(r, a, s))
            : "rewards-earnings" == d || "rewards-earnings-v2" == d
            ? (a.append(i), StampedRewardsEarnings, StampedRewardsEarnings.init(r, a, s))
            : "rewards-spendings" == d || "rewards-spendings-v2" == d
            ? (a.append(i), StampedRewardsSpendings, StampedRewardsSpendings.init(r, a, s))
            : "rewards-vip-tiers" == d
            ? (a.append(i), StampedRewardsVIPTiers, StampedRewardsVIPTiers.init(r, a, s))
            : "rewards-referral" == d
            ? (a.append(i), StampedRewardsReferral, StampedRewardsReferral.init(r, a, s))
            : "rewards-activities" == d
            ? (a.append(i), StampedRewardsActivities, StampedRewardsActivities.init(r, a, s))
            : "rewards-redeem-variable-slider" == d
            ? (a.append(i),
              StampedRewardsRedeemVariableSlider,
              StampedRewardsRedeemVariableSlider.init(r, a, s))
            : "rewards-redeem-select-options" == d &&
              (a.append(i),
              StampedRewardsRedeemSelectOptions,
              StampedRewardsRedeemSelectOptions.init(r, a, s));
        s(".free-tier-banner").lenght < 1 &&
          s(".free-tier-banner").detach().appendTo("#stamped-reviews-widget"),
          Ye("stamped:reviews:widget:loaded");
      }
    }, n);
  }
  function ke(e, a, s) {
    if (s) {
      var r = new Date();
      r.setTime(r.getTime() + 24 * s * 60 * 60 * 1e3);
      var i = "; expires=" + r.toGMTString();
    } else i = "";
    t.cookie = e + "=" + a + i + "; path=/; SameSite=None; Secure";
  }
  function _e(e) {
    for (var a = e + "=", s = t.cookie.split(";"), r = 0; r < s.length; r++) {
      for (var i = s[r]; " " == i.charAt(0); ) i = i.substring(1, i.length);
      if (0 == i.indexOf(a)) return i.substring(a.length, i.length);
    }
    return null;
  }
  function Ce(e) {
    for (var t in e) (null !== e[t] && "" !== e[t] && void 0 !== e[t]) || delete e[t];
    return e;
  }
  var Ie = !1;
  function Te(e) {
    if (s(e).length) {
      var t = s(I).attr("data-animation");
      if ((qe("Animation: " + t), "false" === t || !1 === t));
      else {
        if (1 == Ie) return;
        Ie = !0;
        var a = s(e),
          r = s("html, body"),
          i = s(I).attr("data-offset") || 1;
        x() && (i = s(I).attr("data-offset-mobile") || 1),
          r.on("scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove", function () {
            r.stop(), (Ie = !1);
          }),
          r.animate({ scrollTop: a.offset().top - i }, t || 1e3, function () {
            r.off("scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove"), (Ie = !1);
          });
      }
    }
  }
  function Oe(e) {
    if ("review" == e) {
      ve(null, "reviews");
      var t = s(".new-review-form");
      (a = s(".new-question-form")).slideUp(),
        a.removeClass("stamped-visible"),
        t.hasClass("stamped-visible")
          ? (t.slideUp(), t.removeClass("stamped-visible"), t.attr("aria-expanded", "false"))
          : (t.slideDown(400, function () {
              Te("#stamped-main-widget .new-review-form");
            }),
            t.addClass("stamped-visible"),
            t.attr("aria-expanded", "true")),
        s(t).find("input[type=text]").length > 0 && s(t).find("input[type=text]").get(0).focus();
    } else if ("question" == e) {
      ve(null, "questions");
      var a;
      t = s(".new-question-form");
      (a = s(".new-review-form")).slideUp(),
        a.removeClass("stamped-visible"),
        t.hasClass("stamped-visible")
          ? (t.slideUp(), t.removeClass("stamped-visible"))
          : (t.slideDown(400, function () {
              Te(".new-question-form");
            }),
            t.addClass("stamped-visible"),
            a.attr("aria-expanded", "false")),
        s(t).find("input[type=text]").length > 0 && s(t).find("input[type=text]").get(0).focus();
    }
  }
  function xe(e) {
    var t, a, r;
    (t = s(e).parents(".new-review-form")),
      (r = s(e).attr("data-value")),
      (a = s(e).parent()),
      t.find("input[name='reviewRating']").val(r),
      (function (e, t) {
        t
          .find("a:lt(" + e + ")")
          .removeClass("fa-star-o")
          .addClass("fa-star-checked"),
          t
            .find("a:gt(" + (e - 1) + ")")
            .removeClass("fa-star-checked")
            .addClass("fa-star-o");
      })(r, a),
      (function (e) {
        Array.prototype.slice.call(e.parentNode.children).forEach(function (e) {
          e.setAttribute("aria-pressed", !1);
        });
        var t = e.getAttribute("aria-pressed");
        e.setAttribute("aria-pressed", !JSON.parse(t));
      })(e);
  }
  function Ee(e, t, a, r) {
    var i, n, d, l, p, c, m, u;
    s(I).length &&
      ((n = (function (e, t) {
        for (var a = [], s = 0; s < t; ) a[s++] = e;
        return a.join("");
      })("â˜…", (i = e).reviewRating)),
      (d = o.attr("data-image-url") || ""),
      (l =
        "https://stamped.io/facebookpost?caption=" +
        n +
        " " +
        encodeURIComponent(i.reviewTitle) +
        "&name=" +
        n +
        " " +
        encodeURIComponent(i.reviewTitle) +
        "&description=" +
        encodeURIComponent(i.reviewMessage) +
        "&link=" +
        encodeURIComponent(i.productUrl) +
        "&picture=" +
        encodeURIComponent(d.replace("%3F", "?"))),
      (p =
        "https://www.facebook.com/dialog/feed?app_id=222664514734026&display=popup&link=" +
        encodeURIComponent(l) +
        "&name=" +
        encodeURIComponent(i.reviewTitle) +
        "&redirect_uri=https://stamped.io/shares?productId=" +
        i.productId),
      (c =
        "https://twitter.com/intent/tweet?text=" +
        n +
        " " +
        i.reviewMessage.substr(0, 140) +
        "&url=" +
        encodeURIComponent(i.productUrl)),
      (m = "https://plus.google.com/share?url=" + encodeURIComponent(i.productUrl)),
      (u = s(".stamped-thank-you .stamped-share-links")),
      s(".facebook", u).attr("href", p).attr("target", "_blank"),
      s(".twitter", u).attr("href", c).attr("target", "_blank"),
      s(".google", u).attr("href", m).attr("target", "_blank"),
      s(".stamped-user-review", o).hide(),
      s(".stamped-thank-you", o).show(),
      s(".stamped-thank-you p", o).show(),
      s(".stamped-thank-you .stamped-share-links", o).show(),
      s(".new-review-form", o).hide(),
      s(".edit-review-form", o).hide(),
      s(".stamped-summary-actions-newreview").hide(),
      s("#stamped-button-submit", o).removeAttr("disabled"),
      r && s("#stamped-button-submit", o).val(r),
      Te(I),
      (function (e, t, a) {
        if (null != _e("stamped-user-reviews")) {
          for (var s = JSON.parse(_e("stamped-user-reviews")), r = !1, i = 0; i < s.length; i++)
            if (s[i].pid == e) {
              (r = !0), s[i];
              break;
            }
          !r &&
            e &&
            t &&
            1 == a &&
            (s.length >= 10 && s.splice(0, 1),
            s.push({ pid: e, v: t }),
            ke("stamped-user-reviews", JSON.stringify(s), 1));
        } else if (e && t && 1 == a) {
          var n = [{ pid: e, v: t }];
          ke("stamped-user-reviews", JSON.stringify(n), 1);
        }
      })(a.productId, t.userReference, !0)),
      Ye("stamped:reviews:submitted");
  }
  function Ue(e) {
    var t = 1;
    e && (t = s(e).data("page")), he(t);
  }
  function Re(e, t, a) {
    s || (jQuery && (s = jQuery)), a && s(a).closest(I).length && (o = s(a).closest(I));
    o.attr("data-product-id");
    var r,
      i = s(".stamped-summary-ratings.selected .summary-rating-bar.selected", o).attr(
        "data-rating"
      );
    i && (t = i),
      s(".stamped-sort-select", o).length && (r = s(".stamped-sort-select", o).val()),
      me(e, r, t);
  }
  function Fe(e) {
    var t;
    "qna" == e
      ? (s(".stamped-questions-filter .stamped-summary-actions-clear").hide(),
        s(".stamped-questions-search-input").val(""),
        s(".stamped-questions-search-clear").hide(),
        s(o).removeAttr("data-search-qna"),
        Ue())
      : (s("select.stamped-filter-select").each(function () {
          s(this).val("");
        }),
        s(".stamped-summary-keywords-list li").removeClass("selected"),
        s(o).removeAttr("data-keyword"),
        s(".stamped-reviews-filter .stamped-summary-actions-clear").hide(),
        s(".stamped-reviews", o).removeAttr("data-filtered"),
        s(".stamped-sort-select").length && (t = s(".stamped-sort-select").val()),
        (C = {}),
        s(".stamped-reviews-search-input").val(""),
        s(".stamped-reviews-search-clear").hide(),
        s(o).removeAttr("data-search"),
        oe(),
        me(1, t, null, !0));
  }
  String.linkify ||
    (String.prototype.linkify = function () {
      return this.replace(
        /\b(?:https?|ftp):\/\/[a-z0-9-+&@#\/%?=~_|!:,.;]*[a-z0-9-+&@#\/%=~_|]/gim,
        '<a href="$&" target="_blank">$&</a>'
      )
        .replace(/(^|[^\/])(www\.[\S]+(\b|$))/gim, '$1<a href="http://$2" target="_blank">$2</a>')
        .replace(/[\w.]+@[a-zA-Z_-]+?(?:\.[a-zA-Z]{2,6})+/gim, '<a href="mailto:$&">$&</a>');
    });
  var Ne = !1,
    Ae = null;
  function je(t, a) {
    a || (a = e.location.href), (t = t.replace(/[\[\]]/g, "\\$&"));
    var s = new RegExp("[?&]" + t + "(=([^&#]*)|&|#|$)").exec(a);
    return s ? (s[2] ? decodeURIComponent(s[2].replace(/\+/g, " ")) : "") : null;
  }
  function qe(t, a) {
    var s = "true" == je("stamped_debug") || 1 == e.stamped_debug,
      r = e.stamped_debug_level || je("stamped_debug_level");
    s &&
      (a || console.log("[Stamped.io]", t),
      a && r && console.log("[Stamped.io level" + r + "]", t));
  }
  function Le(e, s) {
    ((a = t.createElement("script")).type = "text/javascript"), (a.charset = "UTF-8"), (a.src = e);
    var r = t.getElementsByTagName("script")[0];
    r.parentNode.insertBefore(a, r), (a.onload = a.onreadystatechange = s);
  }
  function Ge(e, t) {
    try {
      return "undefined" != typeof Storage && (localStorage.setItem(e, JSON.stringify(t)), !0);
    } catch (e) {}
  }
  function Pe(e, t) {
    try {
      if ("undefined" != typeof Storage) {
        var a;
        try {
          a = JSON.parse(localStorage.getItem(e)) || null;
        } catch (t) {
          a = localStorage.getItem(e);
        }
        return a;
      }
      return !1;
    } catch (e) {}
  }
  function De(e, t) {
    var a = Pe("stamped_app_key");
    if (a && a.apiKey) qe(a), Ye("stamped:init:getAppKey", { detail: a }), Ke(a);
    else {
      var s;
      (s = new XMLHttpRequest()).onreadystatechange = function () {
        if (4 === s.readyState && 200 === s.status) {
          var e = JSON.parse(s.responseText);
          if (e && e.apiKey)
            if (
              (Ge("stamped_app_key", e), Ye("stamped:init:getAppKey", { detail: e }), !0 === e.skip)
            );
            else {
              appKey = e.apiKey;
              var t = { apiKey: appKey };
              "undefined" != typeof Shopify ? (t.storeUrl = Shopify.shop) : (t.sId = e.sId), Ke(t);
            }
        }
      };
      var r = "";
      "shopify" == e
        ? (r = "shopShopifyDomain=" + t)
        : "bigcommerce" == e && (r = "storeHash=" + t),
        s.open("GET", "https://stamped.io/api/getappkey?" + r, !0),
        s.send();
    }
  }
  function Ke(t) {
    if (1 == e.isInitializedStamped)
      return (
        qe("Already initalized"), StampedFn.loadWidget(!0), void StampedFn.loadDisplayWidgets()
      );
    if (
      ((e.isInitializedStamped = !0),
      t && (e.StampedGlobalOptions = t),
      e.StampedGlobalOptions && e.StampedGlobalOptions.apiKey)
    ) {
      var a = "true" == je("stamped_force_jquery") || r.is_force_jquery;
      "undefined" == typeof jQuery || 1 == a
        ? Le("https://ajax.googleapis.com/ajax/libs/jquery/1.11.0/jquery.min.js", function () {
            (s = jQuery.noConflict(!0)), j(), (e.isInitializedStamped = !0);
          })
        : (j(0, jQuery), (e.isInitializedStamped = !0));
    }
  }
  var ze = t.getElementById("stamped-script-widget");
  ze || (ze = t.getElementById("stamped-script-init"));
  var We = "";
  ze && (We = ze.src);
  var Me = !1;
  if (
    ((We.indexOf("skipCss=true") > 0 || 1 == r.exclude_main_css) && (Me = !0),
    Me ||
      (function (e) {
        for (var a = t.styleSheets, s = 0, r = a.length; s < r; s++)
          if (a[s] && a[s].href && a[s].href.indexOf(e) > -1) return;
        var i = t.createElement("link");
        (i.rel = "stylesheet"), (i.href = e), (i.type = "text/css");
        var n = t.getElementsByTagName("link")[0];
        if (n) n.parentNode.insertBefore(i, n);
        else {
          var d = t.getElementsByTagName("head")[0];
          i.setAttribute("async", ""), d.appendChild(i);
        }
      })("//cdn1.stamped.io/files/widget.min.css"),
    "undefined" != typeof Shopify)
  ) {
    var $e = !1;
    if (Shopify.shop) {
      if (null != ze) {
        We.indexOf("skip=true") > -1 && ($e = !0);
        var Ve = ze.getAttribute("data-api-key");
        !Ve && We.indexOf("apiKey") > -1 && (Ve = je("apiKey", We)),
          Ve && (($e = !0), Ke({ apiKey: Ve, storeUrl: Shopify.shop }));
      }
      $e || De("shopify", Shopify.shop);
    }
    if (Shopify.Checkout && "undefined" == typeof StampedShopifyCheckout) {
      if ("function" == typeof e.StampedShopifyCheckout) return !1;
      Le("//cdn1.stamped.io/files/shopify-checkout.min.js", function () {
        Ye("stamped:script-shopify-checkout:loaded");
      });
    }
  }
  if (null != ze) {
    var Be = ze.getAttribute("data-store-hash");
    Be && De("bigcommerce", Be);
    var He = ze.getAttribute("data-store-id"),
      Qe = ze.getAttribute("data-api-key"),
      Je = ze.getAttribute("data-auto-init");
    He && Qe && "false" != Je && Ke({ apiKey: Qe, sId: He });
  }
  function Ye(a, s) {
    var r;
    e.CustomEvent
      ? (r = new CustomEvent(a, s))
      : (r = t.createEvent("CustomEvent")).initCustomEvent(a, !0, !0, s);
    try {
      t.dispatchEvent(r);
    } catch (e) {}
  }
  return {
    init: Ke,
    initRewards: G,
    reloadUGC: L,
    toggleForm: Oe,
    setRating: xe,
    submitForm: function (t) {
      var a,
        i,
        n = o.data("label-submitting"),
        d = s(".new-review-form .stamped-button-primary", o).val();
      if (
        (i = (function (e) {
          var t = {};
          s(e).hasClass("new-review-form") || (e = s(e).parents(".new-review-form"));
          var a = s("input,textarea,select,radio", e).serializeArray();
          return (
            s.each(a, function () {
              void 0 !== t[this.name]
                ? (t[this.name].push || (t[this.name] = [t[this.name]]),
                  t[this.name].push(this.value || ""))
                : (t[this.name] = this.value || "");
            }),
            t
          );
        })(t)).reviewRating &&
        i.author &&
        i.reviewMessage.trim()
      ) {
        var l = {
          productName: o.attr("data-name"),
          productId: o.attr("data-product-id"),
          productSKU: o.attr("data-product-sku"),
          productType: o.attr("data-product-type"),
          productDescription: o.attr("data-description"),
          productImageUrl: o.attr("data-image-url"),
          productUrl: o.attr("data-url"),
          reviewSource: "widget",
          userReference: o.attr("data-user-reference"),
        };
        (i = s.extend(i, l)), (a = i);
        var p = new FormData();
        for (var c in i) {
          var m = i[c];
          m.indexOf("+") > -1 &&
            c.indexOf("customFormOption") > -1 &&
            (m = i[c].replace("+", "%2B")),
            p.append(c, m);
        }
        var u = 0;
        for (var h in k) p.append("image" + u, k[u]), (i["image" + u] = k[u]), u++;
        qe(Object.prototype.toString.call(p)), qe(p);
        var v = {
          url:
            r.SECURE_ENDPOINT +
            "/reviews3?" +
            s.param(
              Ce({
                apiKey: e.StampedGlobalOptions.apiKey,
                sId: e.StampedGlobalOptions.sId,
                storeUrl: e.StampedGlobalOptions.storeUrl,
              })
            ),
          cache: !1,
          processData: !1,
          contentType: !1,
          type: "POST",
          data: p._blob ? p._blob() : p,
          beforeSend: function (e) {
            s("#stamped-button-submit", o).attr("disabled", "disabled"),
              n && s("#stamped-button-submit", o).val(n);
          },
          error: function (e) {
            Ye("stamped:reviews:submitError"),
              1 == r.is_ignore_submit_error
                ? Ee(a, e, l, d)
                : (s("#stamped-button-submit", o).removeAttr("disabled"),
                  d && s("#stamped-button-submit", o).val(d));
          },
          success: function (e) {
            Ee(a, e, l, d);
          },
        };
        s.ajax(v);
      }
    },
    submitQuestionForm: function (t) {
      var a = s(t || "#new-question-form"),
        r = s(I);
      if (a.length && r.length) {
        var i = r.data("name"),
          n = r.data("description"),
          d = r.data("product-sku"),
          o = r.data("url"),
          l = r.data("image-url"),
          p = a.serializeArray();
        p.push({ name: "productName", value: i }),
          p.push({ name: "productDescription", value: n }),
          p.push({ name: "productSKU", value: d }),
          p.push({ name: "productUrl", value: o }),
          p.push({ name: "productImageUrl", value: l }),
          p.push({ name: "apiKey", value: e.StampedGlobalOptions.apiKey }),
          p.push({ name: "sId", value: e.StampedGlobalOptions.sId }),
          p.push({ name: "storeUrl", value: e.StampedGlobalOptions.storeUrl }),
          s('input[type="submit"]', a).attr("disabled", "disabled"),
          s.ajax({
            type: "POST",
            url: "https://stamped.io/api/questions",
            data: s.param(p),
            crossDomain: !0,
            success: function (e) {
              a.hide(),
                s(".question-form-wrapper .stamped-form-message-success").show(),
                s(".stamped-form-message-success").attr("aria-live", "polite"),
                a[0].reset(),
                s('input[type="submit"]', a).removeAttr("disabled");
            },
          });
      }
    },
    toggleFormEdit: function () {
      s(".edit-review-form", o).toggle();
    },
    pageQuestions: Ue,
    sortQuestions: function (e) {
      e.value && he(1, e.value);
    },
    pageReviews: Re,
    sortReviews: function (e) {
      o.attr("data-product-id"), e.value && me(1, e.value, null, !0);
    },
    filterReviews: function (e) {
      var t = s("option:first-child", e).text(),
        a = e.value;
      C = {};
      var r,
        i = 1;
      s("select.stamped-filter-select").each(function () {
        var e = s("option:first-child", this).text(),
          t = this.value;
        (C["qt" + i] = e), (C["qv" + i] = t), i++;
      }),
        s(".stamped-reviews-filter .stamped-summary-actions-clear").show(),
        s(".stamped-reviews", o).attr("data-filtered", "true"),
        s(".stamped-sort-select").length && (r = s(".stamped-sort-select").val()),
        me(1, r, null, !0),
        t && a && z({ customOptionTitle: t, customOptionValue: a }, o.attr("data-product-id"));
    },
    filterClear: Fe,
    pageWidget: function (e, t) {
      var a = s(e).data("page"),
        i = s(e).closest("#stamped-reviews-widget");
      i.attr("data-page", a),
        (function (e, t, a) {
          var i = r.SECURE_ENDPOINT + "/widget/reviews",
            n = ye(e, t);
          (a = a || {}),
            s.ajax({
              type: "GET",
              url: i + "?" + s.param(Ce(n)),
              dataType: "json",
              success: function (t, s, r) {
                Se(e, t), a.callback && a.callback();
              },
            });
        })(i, a, t);
    },
    loadBadges: ae,
    loadWidget: ee,
    loadDisplayWidgets: se,
    loadDisplayWidgetsRewards: re,
    voteReview: function (t, a, i) {
      var n = s(t),
        d = n.parent();
      d.fadeTo("slow", 0.3),
        n.addClass("disable-link"),
        s.ajax({
          type: "POST",
          url: r.SECURE_ENDPOINT + "/reviews/vote",
          data: {
            reviewId: a,
            vote: i,
            apiKey: e.StampedGlobalOptions.apiKey,
            sId: e.StampedGlobalOptions.sId,
            storeUrl: e.StampedGlobalOptions.storeUrl,
          },
          success: function (e) {
            s(".stamped-thumbs-up", d).attr("data-count", e.voteUp),
              s(".stamped-thumbs-down", d).attr("data-count", e.voteDown),
              s(".stamped-ugc-modal-vote-up", d).attr("data-count", e.voteUp),
              s(".stamped-ugc-modal-vote-down", d).attr("data-count", e.voteDown),
              s(".stamped-thumbs-up i", d).html("&nbsp; " + e.voteUp),
              s(".stamped-thumbs-down i", d).html("&nbsp; " + e.voteDown),
              d.fadeTo("slow", 1),
              n.removeClass("disable-link");
          },
        });
    },
    openUGCModal: function (a, i, n, d, o, l, p, c, m) {
      var u, h;
      (1 !== d && d) || (a = ge(a, o)), null != a || a.length || F(i, l), p || (p = "en");
      var v,
        g =
          '<div class="stamped-ugc-modal" data-lang="' +
          p +
          '" role="dialog" aria-modal="true" aria-label="Customer Review Photos" data-keyboard="true" tabindex="-1"> <div class="stamped-ugc-modal-wrapper" role="region" aria-roledescription="carousel" aria-label="carousel" aria-label="Shop our Instagram look"><span href="javascript:void(0)" title="Close" aria-label="Close" role="button" class="stamped-modal-close show-mobile" style="display:none;" tabindex="0">X</span> <div class="stamped-ugc-modal-nav stamped-ugc-modal-nav-previous" role="button" data-direction="left" tabindex="0" aria-label="Previous Photo"> <i class="stamped-fa stamped-fa-angle-left"></i> </div> <div class="stamped-ugc-modal-image-wrapper" role="group" aria-roledescription="slides" aria-label="slide"> <div class="stamped-ugc-modal-image"></div> <ul></ul> </div> <div class="stamped-ugc-modal-content"> <span href="javascript:void(0)" title="Close" aria-label="Close" role="button" class="stamped-modal-close" tabindex="0">X</span> <div class="stamped-ugc-modal-content-wrapper"> <div class="stamped-ugc-modal-user"> <div class="stamped-ugc-modal-user-source"></div><h1 class="stamped-ugc-modal-user-username"></h1> </div> <div class="stamped-ugc-modal-caption"></div><div class="stamped-ugc-modal-votes"></div> <div class="stamped-ugc-modal-tags"> <span class="stamped-ugc-modal-tag"><a aria-label="Link to Product" {0} target="_top"> <div class="stamped-ugc-modal-tags-product-image-wrapper"><img {1} class="stamped-ugc-modal-tags-product-image" onerror=\'this.style.display = "none"\' alt="{2}" /></div> <div class="stamped-ugc-modal-tags-product-title">{2}</div> </a><div class="stamped-ugc-modal-tags-btn" data-shoppable-url="{3}"></div> </span> </div> </div> </div> <div class="stamped-ugc-modal-nav stamped-ugc-modal-nav-next" role="button" data-direction="right" tabindex="0" aria-label="Next Photo"> <i class="stamped-fa stamped-fa-angle-right"></i> </div> <div class="stamped-ugc-modal-list-photos" role="group"><ul></ul></div> </div> </div>',
        f =
          (s(n).attr("data-hover-text"),
          s(n).attr("data-shop-button-text"),
          s(n).attr("data-url-param") || ""),
        w = s(n).attr("data-url-store") || e.stamped_global_url_store || "";
      s(n).attr("data-cropped"),
        s(n).attr("data-page"),
        s(n).attr("data-take"),
        s("#stamped-ugc-modal").length ||
          ((u = s(g)).attr("data-modal-type", d),
          u.attr("data-modal-shoppable", m || !1),
          s(u).appendTo(t.body),
          u.focus());
      var y = "",
        b = a.length;
      h || (h = s(".stamped-ugc-modal-tags:first", u).html());
      for (var S = a ? a.length : 0, k = 0; k < b; k++) {
        var _ = a[k],
          C = _.imageUrl;
        C && ((y += templateBlock.formatStringStamped(S, C)), S++),
          _.photos.length &&
            _.photos[0].imageUrl &&
            ((fe[k] = new Image()), (fe[k].src = _.photos[0].imageUrl));
      }
      if ((s(".stamped-ugc-media-block-template", n).append(y), !v)) {
        function I(e) {
          switch ((e.preventDefault(), e.keyCode)) {
            case 37:
              N("left");
              break;
            case 39:
              N("right");
              break;
            case 27:
              x();
          }
        }
        s(t).on("keydown", I),
          u.on("click", ".stamped-modal-close", function (e) {
            e.target == this && !0 === E(e) && x();
          }),
          u.on(
            "click keypress",
            ".stamped-ugc-modal-nav-previous, .stamped-ugc-modal-nav-next",
            function (e) {
              if (!0 === E(e)) {
                var t = s(this).attr("data-direction");
                N(t);
              }
            }
          ),
          we || (we = !0),
          t.addEventListener(
            "touchstart",
            function (e) {
              (T = e.touches[0].clientX), (O = e.touches[0].clientY);
            },
            !1
          ),
          t.addEventListener(
            "touchmove",
            function (e) {
              if (T && O) {
                var t = e.touches[0].clientX,
                  a = e.touches[0].clientY,
                  s = T - t,
                  r = O - a;
                Math.abs(s) > Math.abs(r) && N(s > 0 ? "right" : "left"), (T = null), (O = null);
              }
            },
            !1
          );
        var T = null,
          O = null;
        function x() {
          s(t).off("keydown", I),
            u.remove(),
            (u = null),
            s("body").removeClass("stamped-modal-open");
        }
      }
      v = !0;
      var U = function () {
          var e = Number(s(this).text()) + 1,
            t = s(this).data("image-url");
          s(".stamped-ugc-modal-image-wrapper ul li").removeClass("active"),
            s(".stamped-ugc-modal-image-wrapper ul li:nth-child(" + e + ")").addClass("active"),
            "image" == r.modal_ugc_image_viewer
              ? s(".stamped-ugc-modal-image", u).html(
                  '<img src="' + t + '" alt="Customer Photo" />'
                )
              : s(".stamped-ugc-modal-image", u).css("background-image", "url(" + t + ")"),
            Ye("stamped:ugcmodal:paged");
        },
        R = function () {
          var e = s(this).data("index-review"),
            t = s(this).data("index-photo");
          s(".stamped-ugc-modal-list-photos ul li").removeClass("active"),
            s(
              ".stamped-ugc-modal-list-photos ul li[data-index-review=" +
                e +
                "][data-index-photo=" +
                t +
                "]"
            ).addClass("active"),
            F(e, t),
            Ye("stamped:ugcmodal:paged");
        },
        F = function (i, n) {
          var d = a[i];
          if (null != d && null != d.photos) {
            if (
              (null !== n
                ? ((l = n), n > d.photos.length - 1 && (l = 0))
                : l
                ? l > d.photos.length - 1 && (l = 0)
                : (l = 0),
              !s(".stamped-ugc-modal-list-photos ul li", u).length)
            ) {
              for (var o = 0; o < a.length; o++)
                for (var m = 0; m < a[o].photos.length; m++) {
                  var v = i == o && n == m ? "active" : "",
                    g = (a[o].photos[m].imageUrl, a[o].name + " " + a[o].title),
                    y = a[o].photos[m].imageThumbnailUrl,
                    b = t.createElement("li");
                  (b.className = v), (b.innerHTML = ""), (b.className += " stamped-lazyload");
                  var S = t.createAttribute("data-index-review");
                  if (
                    ((S.value = o),
                    b.setAttributeNode(S),
                    ((T = t.createAttribute("data-index-photo")).value = m),
                    b.setAttributeNode(T),
                    b.setAttribute("role", "button"),
                    b.setAttribute("tabindex", 0),
                    b.setAttribute("aria-label", g),
                    e.LazyLoadStamped && LazyLoadStamped.update)
                  ) {
                    var _ = t.createAttribute("data-bg");
                    (_.value = "url(" + y + ")"), b.setAttributeNode(_);
                  } else b.style.background = "url(" + y + ")";
                  s(".stamped-ugc-modal-list-photos ul", u).append(b), (b.onclick = R);
                }
              s(t).on(
                "click keypress",
                ".stamped-ugc-modal-list-photos li.stamped-lazyload",
                function (e) {
                  E(e) &&
                    (s(this).attr("aria-current", "true"),
                    s(this).siblings().attr("aria-current", "false"));
                }
              );
              try {
                e.LazyLoadStamped && LazyLoadStamped.update && LazyLoadStamped.update();
              } catch (e) {}
            }
            if (
              (s(".stamped-ugc-modal-list-photos li.stamped-lazyload.active").attr(
                "aria-current",
                "true"
              ),
              s(".stamped-ugc-modal-list-photos li.stamped-lazyload.active")
                .siblings()
                .attr("aria-current", "false"),
              null != d.photos[l])
            ) {
              var C = d.photos[l].imageUrl,
                I = d.photos[l].videoUrl;
              C
                ? "image" == r.modal_ugc_image_viewer
                  ? (s("video", s(".stamped-ugc-modal-image", u)).remove(),
                    s(".stamped-ugc-modal-image", u).html(
                      '<img src="' +
                        C +
                        '" alt="' +
                        d.via +
                        " photo uploaded by " +
                        d.name +
                        " on " +
                        d.dateFull +
                        '" />'
                    ))
                  : (s("video", s(".stamped-ugc-modal-image", u)).remove(),
                    s(".stamped-ugc-modal-image", u).css("background-image", "url(" + C + ")"))
                : I &&
                  s(".stamped-ugc-modal-image", u).fadeOut("", function () {
                    s(".stamped-ugc-modal-image", u).css("background-image", 'url("")'),
                      s(".stamped-ugc-modal-image", u).html(
                        '<video class="stamped-ugc-modal-video" src="' +
                          I +
                          '" width="100%" controls autoplay />'
                      ),
                      s(this).fadeIn();
                  });
            }
            for (
              s(".stamped-ugc-modal-image-wrapper ul", u).html(""), ii = 0;
              ii < d.photos.length;
              ii++
            ) {
              var T,
                O = ii === l ? "active" : "",
                x = t.createElement("li");
              (x.className = O),
                (x.innerHTML = ii),
                ((T = t.createAttribute("data-image-url")).value = d.photos[ii].imageUrl),
                x.setAttributeNode(T),
                s(".stamped-ugc-modal-image-wrapper ul", u).append(x),
                (x.onclick = U);
            }
            s(".stamped-ugc-modal-user-source").text(d.via);
            var F = s(".stamped-ugc-modal-user-username", u);
            F.text(d.name),
              F.attr("data-verified-type", d.verifiedType),
              F.attr("data-username", d.name);
            var N = "Verified Buyer",
              A = "Shop Now";
            c && "en" != p && ((N = c.label_verified_buyer || N), (A = c.label_shop_now || A)),
              F.append('<span class="stamped-verified-badge">' + N + "</span>"),
              s(".stamped-ugc-modal-tags-btn", u).append("<span>" + A + "</span>");
            var j = "";
            if (d.rating) {
              for (var q = 0; q < d.rating; q++)
                j += '<i class="stamped-fa stamped-fa-star" aria-hidden="true"></i>';
              for (q = 0; q < 5 - d.rating; q++)
                j += '<i class="stamped-fa stamped-fa-star-o" aria-hidden="true"></i>';
            }
            var L,
              G = "";
            if (d.options && d.options.length) {
              for (G += '<ul class="">', k = 0; k < d.options.length; k++) {
                var P = d.options[k].message,
                  D = d.options[k].value;
                G +=
                  '<li data-value="' +
                  P.toString()
                    .toLowerCase()
                    .trim()
                    .replace(/\s+/g, "-")
                    .replace(/[^\w\-]+/g, "")
                    .replace(/\-\-+/g, "-")
                    .replace(/^-+/, "")
                    .replace(/-+$/, "") +
                  '"><span class="stamped-ugc-modal-options-message">' +
                  P +
                  '</span> <span class="stamped-ugc-modal-options-value">' +
                  D +
                  "</span></li>";
              }
              G += "</ul>";
            }
            d.reply || (d.reply = ""), (L = d.dateFull ? new Date(d.dateFull) : new Date(d.date));
            var K = new timeagoStamped().formatDateString(L);
            for (
              "en" != p && (K = d.date),
                s(".stamped-ugc-modal-caption", u).html(
                  '<div class="stamped-ugc-modal-date" data-date="' +
                    d.date +
                    '">' +
                    K +
                    '</div><div class="stamped-ugc-modal-caption-rating">' +
                    j +
                    '</div><div class="stamped-ugc-modal-caption-options">' +
                    G +
                    '</div><h2 class="stamped-ugc-modal-caption-title">' +
                    (d.title || "") +
                    '</h2> <div class="stamped-ugc-modal-caption-body">' +
                    d.body +
                    '</div> <div class="stamped-ugc-modal-caption-reply">' +
                    d.reply +
                    "</div>"
                ),
                s(".stamped-ugc-modal-votes", u).html(
                  '<span class="stamped-ugc-modal-vote-up" aria-pressed="false" role="button" aria-label="Rate review as helpful" tabindex="0" data-count="' +
                    d.votes.up +
                    '" onclick="StampedFn.voteReview(this, ' +
                    d.review_id +
                    ',1)"><i class="stamped-fa stamped-fa-thumbs-up"></i></span><span class="stamped-ugc-modal-vote-down" aria-pressed="false" tabindex="0" role="button" aria-label="Rate review as not helpful" data-count="' +
                    d.votes.down +
                    '" onclick="StampedFn.voteReview(this, ' +
                    d.review_id +
                    ',-1)"><i class="stamped-fa stamped-fa-thumbs-down"></i></span>'
                ),
                s(".stamped-ugc-modal-tags", u).html(""),
                k = 0;
              k < d.products.length;
              k++
            ) {
              var z = d.products[k];
              (z.title = z.title ? z.title : ""),
                w
                  ? ((z.url = z.url.replace("?storeUrl=https://", "")),
                    (z.url = z.url + "?storeUrl=" + w))
                  : f && (z.url = z.url + "?param=" + f);
              var W = z.imageUrl || z.imageLargeUrl;
              z.imageUrl
                ? s(".stamped-ugc-modal-tags", u).append(
                    h.formatStringStamped(
                      'href="' + z.url + '" rel="nofollow"',
                      'src="' + W + '"',
                      z.title,
                      z.productUrl
                    )
                  )
                : s(".stamped-ugc-modal-tags", u).append(
                    h.formatStringStamped(
                      'href="' + z.url + '" rel="nofollow"',
                      "",
                      z.title,
                      z.productUrl
                    )
                  );
            }
            u.attr("data-review-index", i),
              u.attr("data-photo-index", l),
              s(".stamped-ugc-modal-votes > span").click(function () {
                var e = Array.prototype.slice.call(this.parentNode.children);
                e.forEach(function (e) {
                  e.setAttribute("aria-pressed", !1);
                });
                var t = this.getAttribute("aria-pressed");
                this.setAttribute("aria-pressed", !JSON.parse(t));
              }),
              u.hasClass("open") ||
                (u.addClass("open"),
                s("body").addClass("stamped-modal-open"),
                Ye("stamped:ugcmodal:open"));
          }
        },
        N = function (e) {
          if (u.hasClass("open"))
            if (
              (u.attr("data-review-index"),
              u.attr("data-photo-index"),
              s('[data-direction="right"]', u).removeClass("nav-disabled"),
              s('[data-direction="left"]', u).removeClass("nav-disabled"),
              "left" == e)
            ) {
              var t = s(".stamped-ugc-modal-list-photos ul li.active").prev();
              t.click(), t.length || s('[data-direction="left"]', u).addClass("nav-disabled");
            } else {
              if ("right" != e) return;
              var a = s(".stamped-ugc-modal-list-photos ul li.active").next();
              s(a.click()),
                a.length ||
                  (s('[data-direction="right"]', u).addClass("nav-disabled"),
                  "instagram" == u.attr("data-modal-type") && Ye("stamped:ugcmodal:last"));
            }
        };
      null != a && a.length && F(i, l);
    },
    openUGCPhoto: function (t, a, i, n) {
      if (Ne) {
        for (var d = null, l = 0; l < _.length; l++) _[l].id == t && (d = l);
        null != d && StampedFn.openUGCModal(_, d, s(I), null, null, i, Ae), (Ne = !1);
      } else {
        Ne = !0;
        var p = r.SECURE_ENDPOINT + "/widget/reviews",
          c = s(o).attr("data-product-sku") || "",
          m = "",
          u = "",
          h = [];
        !0 === n
          ? ((a = s(o).attr("data-product-id") || ""),
            (m = s(o).attr("data-name") || ""),
            (u = s(o).attr("data-product-type") || ""))
          : s(".stamped-reviews .stamped-review", o).each(function () {
              var e = s(this).attr("id");
              (e = e.replace("stamped-review-", "")) && h.push(e);
            }),
          s.ajax({
            type: "GET",
            url:
              p +
              "?" +
              s.param(
                Ce({
                  type: "widget-carousel-photos",
                  reviewId: t,
                  reviewIds: h,
                  productId: a,
                  productSKU: c,
                  productType: u,
                  productTitle: m,
                  random: !1,
                  isFillEmpty: !1,
                  page: 1,
                  skip: 100,
                  minRating: 1,
                  isWithPhotos: !0,
                  apiKey: e.StampedGlobalOptions.apiKey,
                  sId: e.StampedGlobalOptions.sId,
                  storeUrl: e.StampedGlobalOptions.storeUrl,
                })
              ),
            dataType: "json",
            success: function (e, r, n) {
              _ = e.data;
              for (var d = null, o = 0; o < _.length; o++) _[o].id == t && (d = o);
              null != d &&
                ((Ae = e.lang),
                StampedFn.openUGCModal(_, d, s(I), null, null, i, Ae, e.translations)),
                (Ne = !1),
                a;
            },
          });
      }
      return !1;
    },
    initOptions: e.StampedGlobalOptions,
    loadSurveyOptin: function (a) {
      var r,
        i = setInterval(function () {
          void 0 !== e.StampedGlobalOptions &&
            (null !== a &&
              a.orderId &&
              s.ajax({
                type: "GET",
                url:
                  "https://stamped.io/api/plugin/facebookmessenger?" +
                  s.param(
                    Ce({
                      apiKey: e.StampedGlobalOptions.apiKey,
                      sId: e.StampedGlobalOptions.sId,
                      storeUrl: e.StampedGlobalOptions.storeUrl,
                      orderId: a.orderId,
                      customerEmail: a.customerEmail,
                    })
                  ),
                success: function (e) {
                  s("body").append(e.html);
                  var a = s("#stamped-facebook-optin .fb-send-to-messenger")[0].outerHTML,
                    r = t.createElement("iframe");
                  (r.height = "100"), (r.width = "100%");
                  var i =
                    "<!DOCTYPE html> <html> <head> <meta charset='utf-8' /> <title></title> </head> <script> var fbPageId, fbUserRef; window.fbAsyncInit = function() { FB.init({ appId : '222664514734026', xfbml : true, version : 'v6.0' }); FB.Event.subscribe('send_to_messenger', function(e) { var modal = window.top.document.getElementById('stamped-facebook-optin'); if (e.event == 'rendered'){ modal.style.display = 'block'; } if (e.event == 'opt_in'){ console.log('hide'); modal.style.display = 'none'; } }); }; (function(d, s, id){ var js, fjs = d.getElementsByTagName(s)[0]; if (d.getElementById(id)) {return;} js = d.createElement(s); js.id = id; js.src = '//connect.facebook.net/en_US/sdk.js'; fjs.parentNode.insertBefore(js, fjs); }(document, 'script', 'facebook-jssdk') ); </script> <body>" +
                    a +
                    "</body> </html>";
                  t.body.appendChild(r),
                    s(r).appendTo("#stamped-facebook-optin .fb-send-to-messenger"),
                    r.contentWindow.document.open(),
                    r.contentWindow.document.write(i),
                    r.contentWindow.document.close();
                },
              }),
            clearInterval(i)),
            ++r >= 5 && clearInterval(i);
        }, 2e3);
    },
    closeSurveyOptin: function () {
      s("#stamped-facebook-optin").remove();
    },
    triggerEvent: Ye,
    on: function (e, a) {
      t.addEventListener
        ? t.addEventListener(e, a)
        : t.attachEvent("on" + e, function () {
            a.call(t);
          });
    },
    jQuery: s,
    stampedLog: qe,
    getOptions: function () {
      return r;
    },
    setOptions: function (e) {
      Object.assign(r, e);
    },
    getLoggedInCustomer: function () {
      return T.customer;
    },
    getDataRewards: function () {
      return T;
    },
    loadLauncherView: V,
    scrollLauncherView: function (e) {
      StampedFn.toggleLauncher(!0),
        setTimeout(function () {
          var t = s(e, y).offset();
          s(".stamped-rewards-content-container", y).scrollTop(t.top - 155),
            qe(s(".stamped-rewards-content-container", y)),
            qe(t),
            qe(e);
        }, 500);
    },
    toggleLauncher: K,
    toggleRewardsModal: K,
    rewardsApplyCode: function (e) {
      $btn = s("#stamped-rewards-apply-code", y);
      var t = s(".stamped-reward-coupon-code", y).text(),
        a = $btn.text(),
        i = $btn.data("type"),
        n = T.links;
      Y("loading");
      var d = r.is_rewards_code_copy || a.indexOf("Copy") > -1 || "copy" == i;
      if ((Ye("stamped:rewards:coupon:applied", { detail: t }), 1 == d)) U(t), Y("active");
      else {
        t = encodeURIComponent(t);
        var o = n.shop + "/discount/" + t;
        r.rewards_apply_discount_url_format &&
          (o = rewards_apply_discount_url_format.replace("{0}", t)),
          (e && e.skip) ||
            s.ajax({
              type: "GET",
              url: o,
              data: {},
              success: function (e, t, a) {
                Y("active");
              },
            });
      }
      return { code: t, setState: Y };
    },
    rewardsReferralClaimCode: function () {
      var t = s("#referral_claim_email", y),
        a = s("#stamped-rewards-claim-code", y),
        r = t.val(),
        i = StampedFn.getOptions();
      r &&
        (X(a, "loading", !0),
        s.ajax({
          type: "POST",
          url:
            i.SECURE_ENDPOINT +
            "/v2/rewards/referral/claim?" +
            s.param({
              apiKey: e.StampedGlobalOptions.apiKey,
              sId: e.StampedGlobalOptions.sId,
              storeUrl: e.StampedGlobalOptions.storeUrl,
              email: r,
              referralCode: i.referral_code,
              debug: null,
            }),
          dataType: "json",
          success: function (e, t, a) {
            V("view-coupon", null, {
              couponCode: e.couponCode,
              title: e.title,
              viewTitle: e.title,
            });
          },
          error: function (e) {
            var t = e.responseJSON
              ? e.responseJSON.message
              : e.responseText
              ? JSON.parse(e.responseText).message
              : "You are not eligible for the reward.";
            s(".stamped-reward-card-error", y).text(t);
          },
          complete: function () {
            X(a, "active", !0, 1e3);
          },
        }));
    },
    rewardsReferralSendEmail: function (t) {
      var a = s("#email-to", y),
        r = s("#email-message", y),
        i = s(t),
        n = a.val(),
        d = r.val(),
        o = StampedFn.getOptions();
      n &&
        (X(i, "loading", !0),
        s.ajax({
          type: "POST",
          url:
            o.SECURE_ENDPOINT +
            "/v2/rewards/referral/send?" +
            s.param({
              apiKey: e.StampedGlobalOptions.apiKey,
              sId: e.StampedGlobalOptions.sId,
              storeUrl: e.StampedGlobalOptions.storeUrl,
              fromEmail: T.customer.customerEmail,
              toEmail: n,
              message: d,
              debug: null,
            }),
          data: {},
          success: function (e, t, a) {},
          error: function (e) {},
          complete: function () {
            X(i, "active", !1, 3e4);
          },
        }));
    },
    rewardsLink: function (e) {
      var t = T.links;
      "login" == e
        ? (top.location.href = t.login)
        : "signup" == e && (top.location.href = t.signup);
    },
    rewardsRedeem: function (t, a, i) {
      X(t, "loading", !0),
        (a = a || {}),
        s.ajax({
          type: "POST",
          url:
            r.SECURE_ENDPOINT +
            "/v2/rewards/redeem?" +
            s.param({
              apiKey: e.StampedGlobalOptions.apiKey,
              sId: e.StampedGlobalOptions.sId,
              storeUrl: e.StampedGlobalOptions.storeUrl,
              campaignId: a.campaignId,
              points: a.points,
            }),
          data: T.customer,
          dataType: "json",
          success: function (e, s, r) {
            a.campaignId && X(t, "active", !0, 1), i && i(e);
          },
        });
    },
    rewardsPointsRefresh: W,
    rewardsReferralCopy: function () {
      var e = s(".stamped-reward-referral-wrapper .stamped-reward-copy-icon", y);
      U(T.customer.urlReferral);
      var t = e.html();
      e.html('<i class="far fa-check"></i>'),
        setTimeout(function () {
          e.html(t);
        }, 3e3);
    },
    rewardsCreateActivity: M,
    rewardsTriggerEarn: Q,
    rewardsTriggerSpend: J,
    getLauncherWindow: function () {
      return y;
    },
  };
};
